<template>
  <div id="editorial-office-submissions-details">
    <div class="ipub-h2 inline-block">Details for Manuscript No.: {{articleDetail.code}}</div>
    <div class="mar-l-10 inline-block"
         v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.MANUSCRIPT_CHECK')">
      <ipub-tooltip placement="bottom"
                    class="mar-b-4">
        <div slot="title">
          Edit checked note
        </div>
        <ipub-icon @click="handleCheckNote"
                   style="font-size:24px"
                   type="icona-CheckNote" />
      </ipub-tooltip>
      <ipub-radio :checked="articleDetail.checked"
                  class="ipub-p2 line-h-40 mar-l-16"
                  @change="handleCheckRadio"
                  label="Checked" />
    </div>
    <div class="mar-b-20 ipubw-p1">Manuscript Status: {{ARTICLE_STATUS[articleDetail.status]}}</div>
    <div class="ipub-list-tab">
      <a v-for="(item) in articleDetail.signList"
         :key="'version'+item"
         @click="changeVersion(item)"
         :class="['ipub-list-tab--status', params.sign===item?'active':'']">Version {{item}}</a>
    </div>
    <div class="ipub-p2 mar-b-16">
      <strong class="ipub-p2 fw-bd">Submission Date: </strong>{{articleDetail.firstSubmitTime?$moment(articleDetail.firstSubmitTime).format('DD / MM / YYYY'):'- -'}}<strong> | </strong>
      <strong class="ipub-p2 fw-bd">Last Revision Date: </strong>{{articleDetail.lastRevisionTime?$moment(articleDetail.lastRevisionTime).format('DD / MM / YYYY'):'- -'}}<strong> | </strong>
      <strong class="ipub-p2 fw-bd">Status Change Date: </strong>{{articleDetail.statusTime?$moment(articleDetail.statusTime).format('DD / MM / YYYY'):'- -'}}<strong> | </strong>
      <strong class="ipub-p2 fw-bd">Last Action Date: </strong>{{articleDetail.lastOperateTime?$moment(articleDetail.lastOperateTime).format('DD / MM / YYYY'):'- -'}}
    </div>
    <div class="content-bg">
      <div class="mar-b-20">
        <div class="ipub-h3 ipub-title-tab mar-b-10 "
             style="line-height: 40px;">Manuscript Information</div>
        <div class="ipub-title-tab-part ipub-p2 fw-bd">
          <div class="flex mar-b-8">
            <div class="ipub-block__span">Article Type</div>
            <div class="ipub-block__font">{{manuscriptType[articleDetail.typeCode]}}</div>
          </div>
          <div class="flex mar-b-8">
            <div class="ipub-block__span">Journal</div>
            <div class="ipub-block__font">
              {{articleDetail.journal&&articleDetail.journal.name||'- - '}}
              <a class="link-color mar-l-10"
                 v-if="user.codeList&&['EDITOR_TASK.MANUSCRIPTS.ASSIGN_EDITOR','EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.TRANSFER'].some(item =>{return user.codeList.some(v=>{return item ===v})})&&['SUBMITTED', 'PENDING_APC_CONFIRM', 'PENDING_REVIEW', 'PENDING_PRE_CHECK', 'PRE_CHECK_DONE'].includes(articleDetail.status)"
                 @click="transfer">
                <ipub-icon style="font-size:16px"
                           type="iconassign_to_editor" />
              </a>
            </div>
          </div>
          <div class="flex mar-b-8">
            <div class="ipub-block__span">Editor</div>
            <div class="ipub-block__font">
              {{articleDetail.editor&&articleDetail.editor.id?articleDetail.editor.firstName+' '+articleDetail.editor.lastName:'- -'}}
              <a class="link-color mar-l-10"
                 v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.ASSIGN_EDITOR')&&articleDetail.signList[0]===articleDetail.sign"
                 @click="changeEditor">
                <ipub-icon style="font-size:16px"
                           type="iconEditPen" />
              </a>
            </div>
          </div>
          <div class="flex mar-b-8">
            <div class="ipub-block__span">Article Title</div>
            <div class="ipub-block__font">{{articleDetail.title}}</div>
          </div>
          <div class="flex mar-b-8">
            <div class="ipub-block__span">Section</div>
            <div class="ipub-block__font">{{articleDetail.section&&articleDetail.section.name||'- -'}}</div>
          </div>
          <div class="flex mar-b-8">
            <div class="ipub-block__span">Special Issue</div>
            <div class="ipub-block__font">
              <span class="ipub-cursor-pointer link-color"
                    @click="viewSpecialIssue"> {{articleDetail.special&&articleDetail.special.titleText||'- -'}}</span>
            </div>
          </div>
          <div class="flex mar-b-8">
            <div class="ipub-block__span">Abstract</div>
            <div class="ipub-block__font">
              <template v-if="articleDetail.summary">
                <template v-if="articleDetail.summary.length>200">
                  <template v-if="showAbstract">{{articleDetail.summary}}</template>
                  <template v-else>{{articleDetail.summary.substr(0, 200)}}...</template>
                  <a class="link-color"
                     @click="()=>{showAbstract = !showAbstract}">
                    {{showAbstract?'Hidden':'View More'}}
                  </a>
                </template>
                <template v-else>{{articleDetail.summary}}</template>
              </template>
              <template v-else>- -</template>
            </div>
          </div>
          <div class="flex mar-b-10">
            <div class="ipub-block__span">Keywords</div>
            <div class="ipub-block__font">
              <template v-if="articleDetail.keyword">
                <span v-for="(item, index) in articleDetail.keyword.split(';')"
                      :key="'detail.keywords'+index">
                  <template v-if="index<articleDetail.keyword.split(';').length-1">{{item+'; '}}</template>
                  <template v-else>{{item}}</template>
                </span>

                <!-- <ipub-label style="margin: 0 6px 10px 0;padding:0 12px;"
                          v-for="(item, index) in articleDetail.keyword.split(',')"
                          :key="'articleDetail.keywords'+index"
                          size="small"
                          circle>{{item}}</ipub-label> -->
              </template>
              <template v-else>- -</template>
            </div>
          </div>
          <div class="flex mar-b-20">
            <div class="ipub-block__span">Author(s)
              <ipub-icon :class="['ipub-p2 mar-l-6 ipub-cursor-pointer rotate',showAuthor?'rotate-180':'']"
                         type="iconArrow"
                         @click="()=>{showAuthor=!showAuthor}" />
            </div>
            <div class="ipub-block__font">
              <!--  -->
              <div class="ipub-p2 flex mar-b-10 fw-bd"
                   v-if="articleDetail.realSubmitter">
                Real Submitter:
                <router-link :to="'/user-manage/manage-users/'+articleDetail.realSubmitter.id+'/personal-information'">
                  <font class="link-color mar-l-10"> {{articleDetail&&articleDetail.realSubmitter && articleDetail.realSubmitter.email}}</font>
                </router-link>
              </div>
              <template v-if="articleDetail.mauthorList && articleDetail.mauthorList.length">
                <div class="ipub-p2 flex mar-b-10"
                     style="align-items: center;"
                     v-for="(item,index) in articleDetail.mauthorList"
                     v-show="(showAuthor && index!==0) || index===0"
                     :key="item.id">
                  <font class="key-color"
                        v-if="item.corresponded">*</font>
                  {{title[item.titleCode]}} {{item.firstName}} {{item.lastName}} (<a class="link-color"
                     @click="sendEmail(item, 'COMMUNCIATING_WITH_AUTHOR')">{{item.email}}</a>
                  <ipub-tooltip placement="bottomLeft"
                                style="margin:0 6px 0">
                    <div slot="title">Copy</div>
                    <ipub-icon class="ipub-c-p"
                               type="iconduplicate"
                               @click="copyUnsub(item.email)" />
                  </ipub-tooltip>)
                  <router-link v-if="item.personId"
                               :to="'/user-manage/manage-users/'+item.personId+'/personal-information'">
                    <ipub-icon style="font-size:16px"
                               class="mar-l-10 link-color"
                               type="iconProfile" />
                  </router-link>
                  <a target="_blank"
                     :href="`https://www.google.com/search?q=${item.firstName}+${item.lastName}`">
                    <ipub-icon style="font-size:16px"
                               class="mar-l-10 link-color"
                               type="iconGoogleScholar" />
                  </a>
                  <ipub-label class="mar-l-10"
                              v-if="item.submited"
                              size="small">Submitted Author</ipub-label>
                  <ipub-label v-if="item.rbed"
                              size="small"
                              class="mar-l-10"
                              type="link">
                    RB
                  </ipub-label>
                  <ipub-label v-if="item.ebed"
                              size="small"
                              class="mar-l-10"
                              type="link">
                    EB
                  </ipub-label>
                  <ipub-tooltip v-if="item.geed"
                                placement="bottomLeft"
                                style="display:flex">
                    <div slot="title">
                      <div class="mar-b-10 ipub-p2"
                           v-for="val in item.specialList"
                           :key="val.id">
                        {{val.titleText}}
                      </div>
                    </div>
                    <ipub-label size="small"
                                class="mar-l-10"
                                type="link">
                      GE
                    </ipub-label>
                  </ipub-tooltip>
                  <ipub-label v-if="item.suggested"
                              size="small"
                              style="margin-right:10px"
                              type="danger">
                    Suggest
                  </ipub-label>
                  <ipub-label v-if="item.sanctioned"
                              size="small"
                              style="margin-right:10px"
                              class="mar-l-10">
                    Sanction Country
                  </ipub-label>
                </div>
              </template>
              <div class="mar-b-4 fw-bd">
                <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.VIEW_ALL_AUTHOR_DETAILS')">
                  <a @click="viewMoreAuthor"
                     class="link-color"
                     style="margin-right:20px"
                     v-if="articleDetail.signList[0]===articleDetail.sign">
                    <ipub-icon type="iconViewDetails"
                               class="ipub-p2" /> View All Authors’ Details
                  </a>
                </template>
                <a class="link-color"
                   @click="viewAuthorQuestionaire">
                  <ipub-icon type="iconViewDetails"
                             class="ipub-p2" /> View Questionaire Summary
                </a>
                <template v-if="declinedFlag">
                  <span class="key-color mar-l-5">
                    <ipub-icon type="iconReminder"
                               class="ipub-p2 " /> Co-Author Declined
                  </span>
                </template>
              </div>
            </div>
          </div>
          <div class="flex mar-b-20">
            <div class="ipub-block__span">Discount</div>
            <div class="ipub-block__font">{{articleDetail.discount? articleDetail.discount+' USD off' : '- -'}}</div>
          </div>
          <div class="flex mar-b-10"
               v-if="articleDetail.foundationList&&articleDetail.foundationList.length">
            <div class="ipub-block__span">Funding</div>
            <div class="ipub-block__font">
              <div class="mar-b-10"
                   v-for="item in articleDetail.foundationList"
                   :key="item.code">
                {{item.name}} <template v-if="item.code">({{item.code}})</template>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mar-b-10"
           v-if="articleDetail.mfileList">
        <div class="ipub-h3 ipub-title-tab mar-b-10"
             @click="()=>{showFiles = !showFiles}">
          Manuscript Files
          <ipub-icon :class="['mar-l-5 rotate',showFiles?'rotate-180':'']"
                     type="iconArrow" />
          <a class="line-h-40 mar-l-20 ipub-p2"
             v-if="articleDetail.signList[0]===articleDetail.sign && !['ONLINE'].includes(articleDetail.status)&&user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.UPDATE_DOCUMENTS ')"
             @click.stop="updateAttachment()">
            <ipub-icon type="icona-UpdateFile1"
                       class="ipub-p2" />
            Update Documents
          </a>
          <a class="line-h-40 mar-l-20 ipub-p2"
             @click.stop="attachmentVersion()">
            <ipub-icon type="iconVersion"
                       class="ipub-p2" />
            Revision History
          </a>
        </div>
        <div v-if="showFiles"
             class="ipub-title-tab-part ipub-p2">
          <div v-for="item in articleDetail.mfileList"
               :key="item.id">
            <div class="ipub-block__span ipub-p2 fw-bd">{{item.typeName}}</div>
            <div class="ipub-block__font mar-b-10">
              <ipub-label style="margin: 0 16px 0 0;"><a class="link-color"
                   @click="downloadMfile(`${domain}/${item.path}`, item.name, item)"
                   target="_blank">{{item.name}}</a>
                <ipub-icon v-if="item.loading"
                           class="mar-l-10"
                           type="loading" />
                <ipub-icon v-else-if="item.progress === 100"
                           @click="downloadMfile(`${domain}/${item.path}`, item.name, item)"
                           class="mar-l-10 ipub-cursor-pointer success-color"
                           type="iconAble" />
                <ipub-icon v-else
                           @click="downloadMfile(`${domain}/${item.path}`, item.name, item)"
                           class="mar-l-10 ipub-cursor-pointer link-color"
                           type="iconDownload1" />
              </ipub-label>
              <div class="ipub-block_font-downloading">
                <div class="ipub-block_font-downloading-content"
                     v-if="item.loading"
                     :style="{width:item.progress+'%'}"></div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="mar-b-10">
        <div class="ipub-h3 mar-b-10 ipub-title-tab"
             style="line-height: 40px;"
             @click="()=>{showAPC = !showAPC}">APC Confirm
          <ipub-icon :class="['mar-l-5 rotate',showAPC?'rotate-180':'']"
                     type="iconArrow" />
          <a class="mar-l-10"
             v-if="!isEditApc && user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.EDIT_APC')"
             @click.stop="editApc">
            <ipub-icon style="font-size:16px"
                       v-if="this.apc.id"
                       type="iconEditPen" />
          </a>
        </div>
        <div class="ipub-title-tab-part"
             v-show="showAPC">
          <div v-if="isEditApc || (!isEditApc && !this.apc.id)">
            <ipub-form ref="apc-confirm-form"
                       :model="apc"
                       :rules="apcRules">
              <ipub-row :gutter="24">
                <ipub-col :span="3">
                  <ipub-form-item prop="price"
                                  label="Journal APC ($)">
                    <ipub-input placeholder="Journal APC ($)"
                                number
                                :fixed="2"
                                v-model.trim="apc.price" />
                    <!-- :disabled="!['SUBMITTED', 'PENDING_APC_CONFIRM'].includes(articleDetail.status)" -->
                  </ipub-form-item>
                </ipub-col>
                <ipub-col :span="3">
                  <ipub-form-item prop="discount"
                                  label="Discount (%)">
                    <ipub-input placeholder="Discount (%)"
                                number
                                :fixed="0"
                                v-model.trim="apc.discount" />
                  </ipub-form-item>
                </ipub-col>
                <ipub-col :span="3">
                  <ipub-form-item prop="discountFee"
                                  label="Discounted Fee ($)">
                    <ipub-input placeholder="Discounted Fee ($)"
                                number
                                :fixed="2"
                                v-model.trim="apc.discountFee" />
                  </ipub-form-item>
                </ipub-col>
                <ipub-col :span="3">
                  <ipub-form-item prop="total"
                                  label="Total ($)">
                    <ipub-input placeholder="Total ($)"
                                number
                                :fixed="2"
                                v-model.trim="apc.total" />
                  </ipub-form-item>
                </ipub-col>
              </ipub-row>
            </ipub-form>
            <div class="flex mar-b-24"
                 v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.SUBMIT_APC_CONFIRM')">
              <font class="key-color">*</font>
              <ipub-radio class="mar-l-10"
                          :checked="apc.satisfied"
                          @change="()=>{apc.satisfied = !apc.satisfied}"
                          label="Requirements satisfied" />
            </div>
            <ipub-button v-if="isEditApc && this.apc.id"
                         style="width:128px"
                         type="primary"
                         plain
                         @click="cancelApc">Cancel</ipub-button>
            <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.SUBMIT_APC_CONFIRM')">
              <ipub-button v-if="isEditApc || !this.apc.id"
                           style="width:128px"
                           type="primary"
                           :disabled="!apc.satisfied"
                           @click="submitAPC">Submit</ipub-button>
            </template>
          </div>
          <div v-else
               class="ipub-p2">
            <ipub-row :gutter="12">
              <ipub-col :span="2.4">
                <span>Journal APC ($)<font class="key-color">*</font></span>
                <span class="mar-l-20">{{apc.price || 0}}</span>
              </ipub-col>
              <ipub-col :span="2">
                <span>Discount (%)</span>
                <span class="mar-l-20">{{apc.discount || 0}}</span>
              </ipub-col>
              <ipub-col :span="2.2">
                <span>Discounted Fee ($)</span>
                <span class="mar-l-20">{{apc.discountFee || articleDetail.discount}}</span>
              </ipub-col>
              <ipub-col :span="2.4">
                <span>Total ($)</span>
                <span class="mar-l-20">{{apc.total || 0}}</span>
              </ipub-col>
              <ipub-col :span="3">
                <span>Requirements satisfied<font class="key-color">*</font></span>
                <span class="mar-l-20">Yes</span>
              </ipub-col>
            </ipub-row>
          </div>
        </div>
      </div>
      <template v-if="!['SUBMITTED', 'PENDING_APC_CONFIRM'].includes(articleDetail.status)">
        <div class="mar-b-10 ">
          <div class="ipub-title-tab mar-b-10 ipub-h3"
               style="line-height: 40px;"
               @click="()=>{showPreCheck = !showPreCheck}">Pre-Check
            <ipub-icon :class="['mar-l-5 rotate',showPreCheck?'rotate-180':'']"
                       type="iconArrow" />
            <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.END_PRE-CHECK')">
              <ipub-label class="ipub-p2 line-h-40 mar-l-12 tab-color"
                          style="background:#fff;height:24px"
                          size="common"
                          type="default"
                          v-if="['PENDING_RESUBMISSION','PENDING_REVIEW', 'PENDING_PRE_CHECK', 'PRE_CHECK_DONE'].includes(articleDetail.status)||(['UNDER_REVIEW'].includes(articleDetail.status) && !macademic.PRE_CHECK.endPreCheck && articleReviewer && articleReviewer.length>0)">
                <font v-if="!['PENDING_RESUBMISSION'].includes(articleDetail.status)"
                      @click.stop="endDecision('PRE_CHECK', false)">End Pre-Check</font>
                <font v-else
                      class="tab-color">End Pre-Check</font>
              </ipub-label>
            </template>
          </div>
          <div class="ipub-title-tab-part"
               v-show="showPreCheck">
            <!-- articleReviewer -->
            <!-- {{['UNDER_REVIEW'].includes(articleDetail.status)}} {{  !macademic.PRE_CHECK.endPreCheck}} -->
            <div class="flex"
                 v-if="['PENDING_RESUBMISSION','PENDING_REVIEW','PENDING_PRE_CHECK', 'PRE_CHECK_DONE'].includes(articleDetail.status) || (['UNDER_REVIEW'].includes(articleDetail.status) && !macademic.PRE_CHECK.endPreCheck && articleReviewer && articleReviewer.length>0)"
                 style="align-items: center;">
              <div style="margin-right:20px"
                   class="ipub-p2 fw-bd mar-b-4 line-h-40">Review Document
                <ipub-tooltip placement="right"
                              type="dark"
                              class="mar-l-10">
                  <div slot="title">Supported file types: PDF, ZIP</div>
                  <ipub-icon type="iconInfo" />
                </ipub-tooltip>
              </div>
              <div class="line-h-40 ipub-p2 tr"
                   style="width: 200px"
                   v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.ADD_NEW_REVIEW_DOCUMENT-EDITOR')">
                <ipub-upload v-if="!['PENDING_RESUBMISSION'].includes(articleDetail.status)&&articleDetail.signList[0]===articleDetail.sign&&!loading.PRE_CHECK"
                             @change="(e)=>{handleUpload(e, 'PRE_CHECK')}">
                  <a class="link-color">
                    <ipub-icon type="iconAdd" /> Add New Review Document
                  </a>
                </ipub-upload>
                <font class="line-color"
                      v-else>
                  <ipub-icon :type="loading.PRE_CHECK?'loading':'iconAdd'" /> Add New Review Document
                </font>
              </div>
            </div>
            <div class="mar-b-12"
                 v-if="macademic.PRE_CHECK">
              <div class="ipub-border ipub-line-block relative mar-b-4"
                   style="padding-right:60px;display: inline-block;margin-right:10px"
                   v-for="item in macademic.PRE_CHECK.macademicFileList"
                   :key="item.id">
                {{item.name}}
                <div class="right-option ipub-p2 flex"
                     style="right: 10px">
                  <ipub-tooltip placement="bottom">
                    <div slot="title">
                      Download
                    </div>
                    <a class="line-h-40"
                       @click="download(`${domain}/${item.path}`, item.name)">
                      <ipub-icon style="font-size:16px"
                                 type="iconDownload1" />
                    </a>
                  </ipub-tooltip>
                  <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.DELETE_REVIEW_DOCUMENT-EDITOR')">
                    <div style="padding: 0 4px"
                         class="line-color line-h-40">|</div>
                    <ipub-tooltip placement="bottom">
                      <div slot="title">
                        Delete
                      </div>
                      <a class="line-h-40"
                         @click="delReviewerDoc(item, 'PRE_CHECK')">
                        <ipub-icon style="font-size:16px"
                                   type="iconDelete" />
                      </a>
                    </ipub-tooltip>
                  </template>
                </div>
              </div>
            </div>
            <template v-if="['PENDING_RESUBMISSION', 'PENDING_REVIEW', 'PENDING_PRE_CHECK', 'PRE_CHECK_DONE'].includes(articleDetail.status) || (['UNDER_REVIEW'].includes(articleDetail.status) && !macademic.PRE_CHECK.endPreCheck && articleReviewer && articleReviewer.length>0)">
              <div class="mar-b-12 ipub-p2 flex"
                   v-if="macademic.PRE_CHECK.person">
                <span class="ipub-p2 fw-bd">Academic Editor</span>
                <div class="mar-l-10">
                  <div>
                    <a class="link-color"
                       @click="openReviewResult(macademic.PRE_CHECK.person, true)">{{macademic.PRE_CHECK.person.firstName}} {{macademic.PRE_CHECK.person.lastName}}</a>
                    <span class="mar-l-10">
                      <template v-if="!macademic.PRE_CHECK.person.decisionStatus">{{macademic.PRE_CHECK.person.currentDecisionNum}} current decision (last invited on {{macademic.PRE_CHECK.person.lastInvitedTime?$moment(macademic.PRE_CHECK.person.lastInvitedTime).format('DD MMMM YYYY'):'--'}})</template>
                      <template v-else>Decision: <font @click="checkDecision('PRE_CHECK')"
                              class="key-color">{{DECISION_STATUS[macademic.PRE_CHECK.person.decisionStatus]}}</font></template>
                    </span>
                  </div>
                  <div v-if="macademic.PRE_CHECK.invitedTime && macademic.PRE_CHECK.person"
                       class="ipub-p2 fw-bd">Invited Date: {{$moment(macademic.PRE_CHECK.invitedTime).format('DD MMMM YYYY')}}</div>
                  <div v-if="macademic.PRE_CHECK.remindTimeList && macademic.PRE_CHECK.remindTimeList.length && macademic.PRE_CHECK.person"
                       class="ipub-p2 fw-bd"> Last Remind Date:
                    <span v-for="(item,index) in macademic.PRE_CHECK.remindTimeList"
                          :key="'PRE_CHECK'+index">
                      <div class="mar-l-10 inline-block">{{$moment(item).format('DD MMMM YYYY')}}</div>
                      <div class="mar-l-10 inline-block"
                           v-if="index !=macademic.PRE_CHECK.remindTimeList.length-1">/</div>
                    </span>
                    <span class="ipub-count mar-l-10"> {{macademic.PRE_CHECK.remindTimeList.length}}</span>
                  </div>
                </div>
              </div>
              <div class="mar-b-20 ipub-p2 fw-bd">
                <template v-if="macademic.PRE_CHECK.person">
                  <template v-if="macademic.PRE_CHECK.person.decisionStatus">
                    <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.CHECK_DECISION')">
                      <ipub-button @click="checkDecision('PRE_CHECK')"
                                   type="primary"
                                   size='small'
                                   :disabled="['PENDING_RESUBMISSION'].includes(articleDetail.status)"
                                   plain>Check Decision</ipub-button>
                    </template>

                    <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.ACKNOWLEDGE_ACADEMIC_EDITOR')">
                      <ipub-button v-if="!macademic.PRE_CHECK.acked"
                                   @click="sendEmail(macademic.PRE_CHECK, macademic.PRE_CHECK.geed?'GE_PRE_CHECK_ACK':'PRE_CHECK_ACK','pre_check_ack')"
                                   type="primary"
                                   size='small'
                                   :disabled="['PENDING_RESUBMISSION'].includes(articleDetail.status)"
                                   plain>Acknowledge</ipub-button>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="!macademic.PRE_CHECK.invitedTime">
                      <ipub-button v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.INVITE_ACADEMIC_EDITOR')"
                                   @click="invite(macademic.PRE_CHECK,'PRE_CHECK', macademic.PRE_CHECK.geed?'GE_INVITE_PRE_CHECK':'INVITE_PRE_CHECK')"
                                   type="primary"
                                   size='small'
                                   :disabled="['PENDING_RESUBMISSION'].includes(articleDetail.status)"
                                   plain>Invite</ipub-button>
                    </template>
                    <template v-else>
                      <template v-if="macademic.PRE_CHECK.sended">
                        <ipub-button v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.REMIND_ACADEMIC_EDITOR')"
                                     @click="sendEmail(macademic.PRE_CHECK,macademic.PRE_CHECK.geed?'GE_PRE_CHECK_REMIND':'PRE_CHECK_REMIND','PRE_CHECK_REMIND')"
                                     type="primary"
                                     size='small'
                                     :disabled="['PENDING_RESUBMISSION'].includes(articleDetail.status)"
                                     plain>Remind</ipub-button>
                        <ipub-button v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.CANCEL_INVITE_ACADEMIC_EDITOR')"
                                     @click="sendEmail(macademic.PRE_CHECK,macademic.PRE_CHECK.geed?'GE_PRE_CHECK_CANCEL':'PRE_CANCEL_INVITE','PRE_CHECK')"
                                     type="primary"
                                     size='small'
                                     :disabled="['PENDING_RESUBMISSION'].includes(articleDetail.status)"
                                     plain>Cancel Invitation</ipub-button>
                      </template>
                      <ipub-button v-else
                                   @click="sendEmail(macademic.PRE_CHECK,macademic.PRE_CHECK.geed?'GE_INVITE_PRE_CHECK':'INVITE_PRE_CHECK','INVITE_PRE_CHECK')"
                                   type="primary"
                                   size="small"
                                   plain>Send Invitation Email</ipub-button>
                    </template>
                  </template>
                </template>
                <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.CHOOSE_ANOTHER_EDITOR')">
                  <ipub-button @click="chooseAnotherEditor(macademic.PRE_CHECK.person, 'PRE_CHECK')"
                               v-if="macademic.PRE_CHECK.sended!=false"
                               type="primary"
                               size='small'
                               :disabled="['PENDING_RESUBMISSION'].includes(articleDetail.status)"
                               plain>Choose another editor</ipub-button>
                </template>

              </div>
            </template>
            <div v-for="item in macademic.PRE_CHECK.macademicHistoryList"
                 :key="item.id"
                 class=" mar-b-8 ipub-p2 relative ipub-bottom-border">
              <div class="mar-b-8">
                <a class="ipub-h3 link-color"
                   @click="openReviewResult(item.person, true)"
                   v-if="item.person">{{title[item.person.titleCode]}} {{item.person.firstName}} {{item.person.lastName}} </a>
                <span class="ipub-p2">({{item.person.email}})</span>
                <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.ACKNOWLEDGE_ACADEMIC_EDITOR')">
                  <a v-if="!item.acked && item.decisionStatus"
                     @click="sendEmail(item, macademic.PRE_CHECK.geed?'GE_PRE_CHECK_ACK':'PRE_CHECK_ACK','pre_check_ack')"
                     class="link-color ipub-p2 fw-bd mar-l-20">Acknowledge</a>
                </template>
              </div>
              <div class="mar-b-8 flex">
                <span class="ipub-p2 fw-bd"
                      style="width: 110px">Invited Date</span>
                <span class="mar-l-10"
                      style="width: calc(100% - 120px)">
                  {{item.invitedTime?$moment(item.invitedTime).format('HH:mm DD / MMMM / YYYY'):'--'}}
                </span>
              </div>
              <div class="mar-b-8 flex">
                <span class="ipub-p2 fw-bd "
                      style="width: 110px">Decision</span>
                <span class="mar-l-10 ipub-cursor-pointer"
                      style="width: calc(100% - 120px)"
                      @click="showDecision(item,'PRE_CHECK')">
                  <font class="key-color"
                        v-if="item.decisionStatus">{{DECISION_STATUS[item.decisionStatus]}}</font>
                  <font v-else>--</font>
                </span>
              </div>
              <div class="mar-b-8 flex"
                   v-if="item.authorNotes">
                <span class="ipub-p2 fw-bd "
                      style="width: 110px">Comments</span>
                <div style="display: inline-block; width: calc(100% - 120px)"
                     class="mar-l-10">
                  <template v-if="item.authorNotes.length>500">
                    <div v-if="showAuthorNotes.PRE_CHECK"
                         v-html="item.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                    <div v-else
                         v-html="item.authorNotes.substr(0, 500).replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')+'...'"></div>
                    <a class="link-color"
                       @click="()=>{showAuthorNotes.PRE_CHECK = !showAuthorNotes.PRE_CHECK}">
                      {{showAuthorNotes.PRE_CHECK?'Hidden':'View More'}}
                    </a>
                  </template>
                  <div v-else
                       v-html="item.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')">
                  </div>
                </div>
              </div>
              <div class="mar-b-8 flex">
                <span class="ipub-p2 fw-bd"
                      style="width: 110px">Decision Date</span>
                <span class="mar-l-10"
                      style="width: calc(100% - 120px)">
                  {{item.completedTime?$moment(item.completedTime).format('HH:mm DD / MMMM / YYYY'):'--'}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="mar-b-10"
           v-if="!['SUBMITTED', 'PENDING_APC_CONFIRM'].includes(articleDetail.status)"
           ref="ReviewHistory">
        <div class="mar-b-10"
             @click="()=>{showPeerReview=!showPeerReview}">
          <div class="ipub-h3 line-h-40 ipub-title-tab mar-b-10">Peer Review
            <ipub-icon :class="['mar-l-5 rotate',showPeerReview?'rotate-180':'']"
                       type="iconArrow" />
            <!-- <ipub-button class="mar-l-10"
                         :disabled="['PENDING_RESUBMISSION', 'PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS', 'PAPER_ACCEPTED', 'REJECTED', 'WITHDRAWN','ONLINE'].includes(articleDetail.status) || articleDetail.signList[0]!=articleDetail.sign"
                         @click.stop="Decision(articleDetail.status)"
                         size='small'>
              <font class="ipub-p2">{{articleDetail.status === 'PENDING_DECISION' ?'Final Decision':'Decision to Author'}}</font>
            </ipub-button> -->
          </div>
        </div>
        <div class="ipub-title-tab-part"
             v-show="showPeerReview">
          <div class="mar-b-20"
               v-if="['RESUBMISSION'].includes(articleDetail.status)">
            <div class="flex mar-b-20">
              <font class="key-color">*</font>
              <ipub-radio class="mar-l-10"
                          :checked="peerViewFlag"
                          :disabled="peerViewHistory"
                          @change="()=>{peerViewFlag = !peerViewFlag}"
                          label="Requirements satisfied" />
            </div>
            <ipub-button style="width:128px"
                         type="primary"
                         plain
                         :disabled="!peerViewFlag ||articleDetail.peerConfirmed || articleDetail.signList[0]!==articleDetail.sign"
                         @click="peerView">Confirm</ipub-button>
          </div>
          <template v-if="!['PENDING_RESUBMISSION'].includes(articleDetail.status)">
            <div class="flex">
              <div class="ipub-p2 fw-bd mar-b-4 line-h-40"
                   style="margin-right:20px">Review Document
                <ipub-tooltip placement="right"
                              type="dark"
                              class="mar-l-10">
                  <div slot="title">Supported file types: PDF, ZIP</div>
                  <ipub-icon type="iconInfo" />
                </ipub-tooltip>
              </div>
              <div class="tr line-h-40 ipub-p2 tr"
                   v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.ADD_NEW_REVIEW_DOCUMENT-REVIEWER')">
                <ipub-upload v-if="(['PENDING_REVIEW', 'PENDING_PRE_CHECK', 'PRE_CHECK_DONE', 'UNDER_REVIEW', 'PENDING_FIRST_DECISION', 'FIRST_DECISION_DONE', 'PENDING_FINAL_DECISION', 'FINAL_DECISION_DONE', 'REVISED_REVIEW'].includes(articleDetail.status)||(['RESUBMISSION'].includes(articleDetail.status) && articleDetail.peerConfirmed))&&articleDetail.signList[0]===articleDetail.sign&&!loading.review"
                             @change="(e)=>{handleUpload(e, 'review')}">
                  <a class="link-color">
                    <ipub-icon type="iconAdd" /> Add New Review Document
                  </a>
                </ipub-upload>
                <font v-else
                      class="line-color">
                  <ipub-icon :type="loading.review?'loading':'iconAdd'" /> Add New Review Document
                </font>
              </div>
            </div>
            <div class="mar-b-20">
              <div class="ipub-border ipub-line-block relative mar-b-4"
                   style="padding-right:60px;display: inline-block;margin-right:10px"
                   v-for="item in articleDetail.reviewerDocumentList"
                   :key="item.id">
                {{item.name}}
                <div class="right-option ipub-p2 flex"
                     style="right: 10px">
                  <ipub-tooltip placement="bottom">
                    <div slot="title">
                      Download
                    </div>
                    <a class="line-h-40"
                       @click="download(`${domain}/${item.path}`, item.name)">
                      <ipub-icon style="font-size:16px"
                                 type="iconDownload1" />
                    </a>
                  </ipub-tooltip>
                  <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.DELETE_REVIEW_DOCUMENT-REVIEWER') ">
                    <template v-if="(['PENDING_REVIEW', 'PENDING_PRE_CHECK', 'PRE_CHECK_DONE', 'UNDER_REVIEW', 'PENDING_FIRST_DECISION', 'FIRST_DECISION_DONE', 'PENDING_FINAL_DECISION', 'FINAL_DECISION_DONE', 'REVISED_REVIEW'].includes(articleDetail.status)||(['RESUBMISSION'].includes(articleDetail.status) && articleDetail.peerConfirmed))&&articleDetail.signList[0]===articleDetail.sign">
                      <div style="padding: 0 4px"
                           class="line-color line-h-40">|</div>
                      <ipub-tooltip placement="bottom">
                        <div slot="title">
                          Delete
                        </div>
                        <a class="line-h-40"
                           @click="delReviewerDoc(item)">
                          <ipub-icon style="font-size:16px"
                                     type="iconDelete" />
                        </a>
                      </ipub-tooltip>
                    </template>
                  </template>
                </div>
              </div>
            </div>
            <template>
              <div class="mar-b-16">
                <div class="ipub-p2 fw-bd mar-b-10">Default Due Days <font class="font-color ipub-p2">- Calculate from the Agreed Date</font>
                </div>
                <ipub-input class="ipub-p2"
                            @blur="onDueDaysChange"
                            :disabled="!['PENDING_REVIEW', 'PENDING_PRE_CHECK', 'PRE_CHECK_DONE', 'UNDER_REVIEW', 'PENDING_FIRST_DECISION', 'FIRST_DECISION_DONE', 'PENDING_FINAL_DECISION', 'FINAL_DECISION_DONE', 'REVISED_REVIEW'].includes(articleDetail.status) && (!(['RESUBMISSION'].includes(articleDetail.status) && articleDetail.peerConfirmed)) || articleDetail.signList[0]!==articleDetail.sign || !(user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.EDIT_DEFAULT_REVIEW_DUE_DAYS'))"
                            style="width:350px"
                            placeholder="Input Default Due Days"
                            v-model="dueDays" />
              </div>
              <div class="mar-b-20">
                <div class="ipub-p2 fw-bd mar-b-10">Add Reviewers</div>
                <div class="flex">
                  <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.SEARCH_REVIEWERS')">
                    <ipub-input class="ipub-p2"
                                v-model.trim="reviewerKeyword"
                                :disabled="!['PENDING_REVIEW', 'PENDING_PRE_CHECK', 'PRE_CHECK_DONE', 'UNDER_REVIEW', 'PENDING_FIRST_DECISION', 'FIRST_DECISION_DONE', 'PENDING_FINAL_DECISION', 'FINAL_DECISION_DONE', 'REVISED_REVIEW'].includes(articleDetail.status)&& (!(['RESUBMISSION'].includes(articleDetail.status) && articleDetail.peerConfirmed))||articleDetail.signList[0]!==articleDetail.sign"
                                style="width:285px;margin-right:10px"
                                placeholder="Search or add by name, email" />
                    <ipub-button type="primary"
                                 class="ipub-h3 line-h-40"
                                 :disabled="!['PENDING_REVIEW', 'PENDING_PRE_CHECK', 'PRE_CHECK_DONE', 'UNDER_REVIEW', 'PENDING_FIRST_DECISION', 'FIRST_DECISION_DONE', 'PENDING_FINAL_DECISION', 'FINAL_DECISION_DONE', 'REVISED_REVIEW'].includes(articleDetail.status)&& (!(['RESUBMISSION'].includes(articleDetail.status) && articleDetail.peerConfirmed))||articleDetail.signList[0]!==articleDetail.sign"
                                 @click="searchReviewers(reviewerKeyword)"
                                 icon="iconSearch1"></ipub-button>
                  </template>

                  <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.IMPORT_REVIEWERS')">
                    <ipub-button @click="importReviewer"
                                 :disabled="!['PENDING_REVIEW', 'PENDING_PRE_CHECK', 'PRE_CHECK_DONE', 'UNDER_REVIEW', 'PENDING_FIRST_DECISION', 'FIRST_DECISION_DONE', 'PENDING_FINAL_DECISION', 'FINAL_DECISION_DONE', 'REVISED_REVIEW'].includes(articleDetail.status)&& (!(['RESUBMISSION'].includes(articleDetail.status) && articleDetail.peerConfirmed))||articleDetail.signList[0]!==articleDetail.sign"
                                 type="primary">Import</ipub-button>
                  </template>

                  <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.VIEW_REVIEWERS')">
                    <a @click="searchAndAddReviewers"
                       style="margin-top:20px"
                       v-if="(['PENDING_REVIEW', 'PENDING_PRE_CHECK', 'PRE_CHECK_DONE', 'UNDER_REVIEW', 'PENDING_FIRST_DECISION', 'FIRST_DECISION_DONE', 'PENDING_FINAL_DECISION', 'FINAL_DECISION_DONE', 'REVISED_REVIEW'].includes(articleDetail.status)||(['RESUBMISSION'].includes(articleDetail.status) && articleDetail.peerConfirmed))&&articleDetail.signList[0]===articleDetail.sign"
                       class="mar-l-20 ipub-p2 fw-400 link-color">Search and Add Reviewers</a>
                    <font v-else
                          style="margin-top:20px"
                          class="mar-l-20 ipub-p2 fw-400 line-color">Search and Add Reviewers</font>
                  </template>

                </div>
              </div>
            </template>
            <div v-if="tempReviewer&&tempReviewer.length"
                 class="mar-b-20">
              <div class="mar-b-20 relative ipub-bottom-border"
                   v-for="(item, index) in tempReviewer"
                   :key="'tempReviewer'+item.id">
                <div class="relative">
                  <div class="ipub-h3 mar-b-12 flex">
                    <font class="ipub-c-p"
                          style="margin-right:10px"
                          @click="openReviewResult(item)">
                      {{title[item.titleCode]}} {{item.firstName}} {{item.lastName}}
                    </font>
                    <ipub-tooltip placement="bottom"
                                  class="ipub-c-p"
                                  style="margin-right:10px"
                                  v-if="item.remark">
                      <div slot="title">{{item.remark}}</div>
                      <ipub-icon type="iconDetails" />
                    </ipub-tooltip>
                    <font class="ipub-p2 fw-bd">
                      <ipub-label v-if="item.authored"
                                  size="small"
                                  style="margin-right:10px"
                                  type="danger">
                        AUTHOR
                      </ipub-label>
                      <!-- <template v-if="item.roleList"> -->
                      <ipub-label v-if="item.rbed"
                                  size="small"
                                  style="margin-right:10px"
                                  type="link">
                        RB
                      </ipub-label>
                      <ipub-label v-if="item.ebed"
                                  size="small"
                                  style="margin-right:10px"
                                  type="link">
                        EB
                      </ipub-label>
                      <ipub-label v-if="item.geed"
                                  size="small"
                                  style="margin-right:10px"
                                  type="link">
                        GE
                      </ipub-label>
                      <ipub-tooltip placement="right"
                                    style="margin-right:10px"
                                    v-if="item.affed">
                        <div slot="title">This reviewer and the author belongs to the same Affiliation.</div>
                        <ipub-label type="danger"
                                    size="small"
                                    style="margin-right:10px"
                                    active>
                          Same Affiliations
                        </ipub-label>
                      </ipub-tooltip>
                      <template v-if="item.lastMinvitedTime && $moment().diff($moment(item.lastMinvitedTime), 'days')+1<publisherInfo.reviewLimitDay">
                        <ipub-tooltip placement="bottomLeft">
                          <div slot="title">
                            <div v-if="showReviewTimeInfo && showReviewTimeInfo.length">
                              <div v-for="(itemInfo,indexInfo) in showReviewTimeInfo"
                                   :key="itemInfo.id+indexInfo">
                                {{itemInfo.invitedEditor && itemInfo.invitedEditor.firstName}} {{itemInfo.invitedEditor && itemInfo.invitedEditor.lastName}} ({{itemInfo.invitedEditor && itemInfo.invitedEditor.email}}) of the Manuscript ({{itemInfo.code}}) has invited on {{itemInfo.invitedTime?$moment(itemInfo.invitedTime).format('HH : mm DD / MM / YYYY'):'- -'}}.
                              </div>
                            </div>
                            <span v-else>--</span>
                          </div>
                          <ipub-label style="margin-right:10px"
                                      type="danger"
                                      size="small"
                                      active
                                      @mouseover="overReviewTime(item)">
                            <!-- Less {{$moment().diff($moment(item.lastReviewTime), 'days')}} days -->
                            Less than {{publisherInfo.reviewLimitDay}} days
                          </ipub-label>
                        </ipub-tooltip>
                      </template>
                      <!-- </template> -->
                      <template v-if="item.mailListTypeList&&item.mailListTypeList.length">
                        <template v-for="val in item.mailListTypeList">
                          <ipub-label v-if="val==='PUBLISHER_BLACKLIST'"
                                      :key="item.id+'record.mailListTypeList'+val"
                                      size="small"
                                      style="margin-right:10px"
                                      type="warning">
                            Blacklist
                          </ipub-label>
                        </template>
                      </template>
                      <font class="mar-l-10 key-color ipub-p2"
                            v-if="item.declinedReviewerList&&item.declinedReviewerList.length">
                        <ipub-tooltip placement="bottomLeft">
                          <div slot="title">
                            Rejected Reviewer
                          </div>
                          <ipub-icon style="font-size:20px"
                                     type="iconreviewer" />
                        </ipub-tooltip>
                        <template v-for="(val, num) in item.declinedReviewerList">
                          <a :key="val.id"
                             href="">
                            V{{val.sign}}<template v-if="num !== item.declinedReviewerList.length-1">,</template>
                          </a>
                        </template>
                      </font>
                      <font class="mar-l-10 warning-color ipub-p2"
                            v-if="item.adoptedReviewerList&&item.adoptedReviewerList.length">
                        <ipub-tooltip placement="bottomLeft">
                          <div slot="title">
                            Unaccepted Report
                          </div>
                          <ipub-icon style="font-size:20px"
                                     type="icona-RejectReviewer" />
                        </ipub-tooltip>
                        <template v-for="(val, num) in item.adoptedReviewerList">
                          <a :key="val.id"
                             href="">
                            V{{val.sign}}<template v-if="num !== item.adoptedReviewerList.length-1">,</template>
                          </a>
                        </template>
                      </font>
                      <font class="mar-l-10 link-color ipub-p2"
                            v-if="item.historyReviewerList&&item.historyReviewerList.length">
                        <ipub-tooltip placement="bottomLeft">
                          <div slot="title">
                            Review completed in historical version
                          </div>
                          <ipub-icon style="font-size:20px"
                                     type="icona-AcceptReviewer" />
                        </ipub-tooltip>
                        <template v-for="(val, num) in item.historyReviewerList">
                          <a :key="val.id"
                             href="">
                            V{{val.sign}}<template v-if="num !== item.historyReviewerList.length-1">,</template>
                          </a>
                        </template>
                      </font>
                    </font>
                  </div>
                  <div class="right-option ipub-p2 flex"
                       style="right: 10px;top:calc(50% - 24px)">
                    <ipub-tooltip placement="bottom">
                      <div slot="title">
                        Reviewer Info
                      </div>
                      <a class="line-h-40"
                         @click="openLink(item,'person')">
                        <ipub-icon style="font-size:24px"
                                   type="iconDetails" />
                      </a>
                    </ipub-tooltip>
                    <div style="padding: 0 10px"
                         class="line-color line-h-40">|</div>
                    <ipub-tooltip placement="bottom">
                      <div slot="title">
                        Details
                      </div>
                      <a class="line-h-40"
                         @click="openReviewResult(item)">
                        <ipub-icon style="font-size:24px"
                                   type="iconViewDetails" />
                      </a>
                    </ipub-tooltip>
                    <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.CONFIRM_INVITE')">
                      <div style="padding: 0 10px"
                           class="line-color line-h-40">|</div>
                      <ipub-tooltip placement="bottom">
                        <div slot="title">
                          Confirm Invite
                        </div>
                        <a @click="inviteReviewer(item, index)"
                           class="line-h-40">
                          <ipub-icon style="font-size:24px"
                                     type="iconAble" />
                        </a>
                        <!-- <a @click="sendEmail(item, '','confirmInvite',index)"
                   class="line-h-40">
                  <ipub-icon style="font-size:24px"
                             type="iconAble" />
                </a> -->
                      </ipub-tooltip>
                    </template>
                    <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.DELETE_SELECTED_REVIEWER')">
                      <div style="padding: 0 10px"
                           class="line-color line-h-40">|</div>
                      <ipub-tooltip placement="bottom">
                        <div slot="title">
                          Delete
                        </div>
                        <a class="line-h-40"
                           @click="delReviewer(item)">
                          <ipub-icon style="font-size:24px"
                                     type="iconDelete" />
                        </a>
                      </ipub-tooltip>
                    </template>

                  </div>
                </div>

                <div class="ipub-p2">
                  <div class="flex mar-b-4">
                    <div class="ipub-p2 fw-bd"
                         style="width: 100px">Email</div>
                    <div class="mar-l-10"
                         style="width: calc(100% - 110px)">{{item.email}}</div>
                  </div>
                  <div class="flex mar-b-4">
                    <div class="ipub-p2 fw-bd"
                         style="width: 100px">Affiliation</div>
                    <div class="mar-l-10"
                         style="width: calc(100% - 110px)">
                      <div style="width: calc(100% - 150px)">
                        {{item.affiliation}}
                      </div>
                    </div>
                  </div>
                  <div class="flex mar-b-4">
                    <div class="ipub-p2 fw-bd"
                         style="width: 100px">H-Index</div>
                    <div class="mar-l-10 flex"
                         style="width: calc(100% - 110px)">
                      {{item.hindex}}
                      <ipub-tooltip style="width:100%"
                                    class="mar-l-10 ipub-p2">
                        <div slot="title">
                          <font v-if="item.hindexUrl">H-Index URL</font>
                          <font v-else>Link to Scopus</font>
                        </div>
                        <a :href="item.hindexUrl"
                           @click="openLink(item)"
                           target="_blank">
                          <ipub-icon type="iconReference"
                                     class="link-color" />
                        </a>
                      </ipub-tooltip>
                    </div>
                  </div>
                  <div class="flex mar-b-4">
                    <div class="ipub-p2 fw-bd"
                         style="width: 200px">Research Keywords</div>
                    <div class="mar-l-10"
                         style="width: calc(100% - 110px)">
                      <template v-if="item.keyword">
                        {{item.keyword.split(';').join('; ')}}
                        <!-- <ipub-label :style="{margin: '0 16px 10px 0'}"
                                    v-for="(item, index) in item.keyword.split(',')"
                                    :key="'item.keywords'+index"
                                    size="small"
                                    circle
                                    hover>{{item}}</ipub-label> -->
                      </template>
                      <template v-else>- -</template>
                    </div>
                  </div>
                </div>
                <div class="font-color flex ipub-p2 mar-b-20">
                  <ipub-icon style="font-size:16px;margin-right:4px"
                             type="iconTime" />
                  Last Review Date: {{item.lastReviewTime?$moment(item.lastReviewTime).format('DD / MM / YYYY'):'- -'}}
                  <ipub-icon style="font-size:16px;margin-right:4px"
                             class="mar-l-10"
                             type="icona-NoResponse" />
                  No Response: {{item.noResponseNum || '- -'}}
                  <ipub-icon style="font-size:16px;margin-right:4px"
                             class="mar-l-10"
                             type="iconAble" />
                  Agreed: {{item.agreedNum || '- -'}}
                </div>
              </div>
            </div>
            <div class="relative mar-b-10">
              <div class="ipub-list-tab">
                <template v-for="(item, key) in reviewerCountObj">
                  <a :key="'reviewerCountObj'+key"
                     @click="changeStatus(key)"
                     style="margin-right:40px;margin-bottom:10px;"
                     :class="['ipub-list-tab--status',(reviewerPrasms.status===key||(reviewerPrasms.status===''&&key==='all'))?'active':'']">{{REVIEWER_STATUS[key] || 'All Status'}} ({{item || 0}})</a>
                </template>
              </div>

              <div class="right-option ipub-p2 fw-bd"
                   style="top:-10px">
                <ipub-button type="primary"
                             size="small"
                             @click="reviewHistory">Review History</ipub-button>
              </div>
            </div>
            <div class="page-content mar-b-30">
              <ipub-table :columns="columns"
                          border
                          :pagination="pagination"
                          :dataSource="articleReviewer">
                <template v-slot:status="{text, record}">
                  <!-- <div class="flex-center">
                <div style="width:12px;height:12px;border-radius:6px"
                     :class="'ipub-reviewer-count-item--'+text"></div>
                <font :class="['mar-l-10', 'ipub-reviewer-status-item--'+text]">{{REVIEWER_STATUS[text]}}</font>
              </div> -->
                  <template v-if="text!=='DECLINED'">
                    <font class="flex ipub-c-p">{{REVIEWER_STATUS[text]}}</font>
                    <ipub-tooltip placement="bottom"
                                  class="mar-l-10"
                                  v-if="text==='COMPLETED' && user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.DOWNLOAD_REVIEW_CERTIFICATE')">
                      <div slot="title">
                        <div class="mar-b-4 ipub-p2">
                          Download Certificate
                        </div>
                      </div>
                      <ipub-icon type="iconCertificate"
                                 @click="createCanvans(record, 'rc-c')"
                                 class="ipub-c-p" />
                    </ipub-tooltip>
                  </template>
                  <template v-else>
                    <ipub-tooltip placement="bottom">
                      <div slot="title">
                        <div class="mar-b-4 ipub-p2">
                          Reason: {{reviewRefuse[record.reasonCode]}}
                        </div>
                        <div v-if="record.reason"
                             class="ipub-p2"
                             v-html="record.reason.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')||'--'"></div>
                      </div>
                      {{REVIEWER_STATUS[text]}}
                    </ipub-tooltip>
                  </template>
                </template>
                <template v-slot:email="{record}">
                  <div>
                    <span class="link-color ipub-c-p"
                          @click="openLink(record,'person')"
                          v-if="record.personId">{{record.email}}</span>
                    <font v-else>{{record.email}}</font>
                    <ipub-tooltip placement="bottom"
                                  class="ipub-c-p mar-l-10"
                                  style="margin-right:10px"
                                  v-if="record.remark">
                      <div slot="title">
                        <div v-html="record.remark.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                      </div>
                      <ipub-icon type="iconDetails" />
                    </ipub-tooltip>
                    <div>
                      <!-- <div v-if="record.affed"
                       style="margin-right:10px"
                       class="ipub-label key-bg content-color color-label">
                    Same Affiliations
                  </div> -->
                      <ipub-tooltip placement="right"
                                    v-if="record.affed">
                        <div slot="title">This reviewer and the author belongs to the same Affiliation.</div>
                        <ipub-label type="danger"
                                    active
                                    style="margin-right:10px"
                                    size="small">
                          Same Affiliations
                        </ipub-label>
                      </ipub-tooltip>
                      <ipub-label style="margin-right:10px"
                                  type="danger"
                                  size="small"
                                  active
                                  v-if="record.reviewLimitDay">
                        Less than {{record.reviewLimitDay}} days
                      </ipub-label>
                    </div>
                  </div>

                </template>
                <template v-slot:decisionStatus="{text, record}">
                  <!-- <template v-if="text">
                <div style="width:12px;height:12px;border-radius:6px"
                     :class="'ipub-decision-count-item--'+text"></div>
                <font :class="['mar-l-10', 'ipub-decision-status-item--'+text]">{{DECISION[text]}}</font>
              </template> -->
                  <template v-if="text">
                    <ipub-tooltip v-if="record.seq"
                                  style="margin-right:4px"
                                  placement="bottom">
                      <div slot="title">
                        Accepted Report
                      </div>
                      <strong style="font-size:16px"
                              class="success-color">
                        <ipub-icon type="iconAble" />
                      </strong>
                    </ipub-tooltip>
                    <ipub-tooltip v-else
                                  style="margin-right:4px"
                                  placement="bottom">
                      <div slot="title">
                        Report not Accepted
                      </div>
                      <strong style="font-size:16px"
                              class="key-color">
                        <ipub-icon type="iconCancel" />
                      </strong>
                    </ipub-tooltip>
                    <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.VIEW_REPORTS')">
                      <a @click="detail(record)"
                         class="link-color">{{DECISION[text]}}</a>
                    </template>
                    <template v-else>
                      <div class="link-color">{{DECISION[text]}}</div>
                    </template>
                  </template>
                  <template v-else>- -</template>
                </template>
                <template v-slot:reviewDueTime="{record,text}">
                  <template v-if="text">
                    {{$moment(text).format('DD / MM / YYYY')}}
                    <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.EDIT_REVIEW_DUE_DATE')">
                      <a class="link-color"
                         v-if="record.status !== 'COMPLETED'&&articleDetail.signList[0]===articleDetail.sign"
                         @click="changeDueDate(record)">
                        <ipub-icon class="mar-l-10"
                                   type="iconEditPen" />
                      </a>
                    </template>
                  </template>
                  <template v-else>- -</template>
                </template>
                <template v-slot:remind="{record}">
                  <template v-if="record.remindList && record.remindList.length">
                    <ipub-tooltip placement="bottomLeft">
                      <div slot="title">
                        <div v-for="item in record.remindList"
                             :key="item.id">
                          {{item.remindTime ?$moment(item.remindTime).format('DD / MM / YYYY'):'--'}}
                        </div>
                      </div>
                      <div class="flex"
                           style="align-item:center">
                        <div>
                          <div v-for="item in record.remindList.slice(0,2)"
                               :key="item.id">
                            {{item.remindTime ? $moment(item.remindTime).format('DD / MM / YYYY'):'--'}}
                          </div>
                        </div>
                        <span v-if="record.remindList && record.remindList.length"
                              class="ipub-count mar-l-10">{{record.remindList.length}}</span>
                      </div>
                    </ipub-tooltip>
                  </template>
                  <template v-else>- -</template>
                </template>
                <template v-slot:name="{record}">
                  <a class="link-color"
                     @click="openReviewResult(record)">
                    {{record.firstName}} {{record.lastName}}
                  </a>

                </template>
                <template v-slot:suggest="{record,index}">
                  <ipub-input number
                              style="width:100px"
                              @keydown.native="limitInputValue"
                              @blur=" handleSuggest(record.id,record.suggestReferNum,record.version,index)"
                              v-model="record.suggestReferNum" />

                </template>
                <template v-slot:actions="{ record }">
                  <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.VIEW_REPORTS')">
                    <ipub-tooltip v-show="['COMPLETED'].includes(record.status)"
                                  placement="bottomLeft">
                      <div slot="title">
                        Details
                      </div>
                      <ipub-icon @click="detail(record)"
                                 type="iconViewDetails" />
                    </ipub-tooltip>
                  </template>

                  <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.SEND_REVIEW_REMINDER')">
                    <ipub-tooltip v-show="['NO_RESPONSE', 'AGREED'].includes(record.status)&&articleDetail.signList[0]===articleDetail.sign"
                                  placement="bottomLeft"
                                  :class="record.status==='NO_RESPONSE'?'border-right':''">
                      <div slot="title">
                        Send Remind Letter
                      </div>
                      <ipub-icon @click="sendEmail(record, 'REVIEW_TIME_OUT_REMINDER', 'remind')"
                                 type="iconSend" />
                    </ipub-tooltip>
                  </template>

                  <ipub-tooltip v-show="['DECLINED'].includes(record.status)"
                                placement="bottomLeft">
                    <div slot="title">
                      Details
                    </div>
                    <ipub-icon @click="openRejectReason(record)"
                               type="icona-RejectReason" />
                  </ipub-tooltip>
                  <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.CANCEL_INVITE_REVIEWER')">
                    <ipub-tooltip v-show="['NO_RESPONSE','AGREED'].includes(record.status)"
                                  placement="bottomLeft">
                      <div slot="title">
                        Cancel
                      </div>
                      <!-- <ipub-icon @click="removeReviewer(record)"
                           type="iconCancel" /> -->
                      <ipub-icon @click="sendEmail(record, 'CANCEL_REVIEW_INVITATION','cancel_review_invitation')"
                                 type="iconCancel" />
                    </ipub-tooltip>
                  </template>

                  <div class="ipub-p2"
                       v-show="['LATE', 'TERMINATED_BY_EDITOR'].includes(record.status)">
                    - -
                  </div>
                </template>
              </ipub-table>
            </div>
          </template>

          <div class="line-h-40 relative mar-b-12"
               v-if="articleDetail.suggestReviewerList && articleDetail.suggestReviewerList.length">
            <div class="ipub-p2 fw-400">Suggest Reviewer</div>
            <div class="ipub-p2 ipub-border ipub-line-block relative mar-b-4">
              <template v-for="item in articleDetail.suggestReviewerList">
                {{item.firstName}} {{item.lastName}} ( <a :key="item.id"
                   class="link-color"
                   @click="copyUnsub(item.email)">{{item.email}}</a> );
              </template>
            </div>
          </div>

          <div class="line-h-40 relative mar-b-12"
               v-if="articleDetail.opposeReviewerList && articleDetail.opposeReviewerList.length">
            <div class="ipub-p2 fw-400">Oppose Reviewer</div>
            <div class="ipub-p2 ipub-border ipub-line-block relative mar-b-4">
              <template v-for="item in articleDetail.opposeReviewerList">
                {{item.firstName}} {{item.lastName}} ( <a :key="item.id"
                   class="link-color"
                   @click="copyUnsub(item.email)">{{item.email}}</a> );
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="mar-b-10"
           v-if="articleDetail.autoReplyMeditor&&articleDetail.autoReplyMeditor.authorReply">
        <div class="ipub-h3 line-h-40 ipub-title-tab mar-b-10"
             @click="()=>{showAuthorResponseEditor=!showAuthorResponseEditor}">Author Response to Editor
          <ipub-icon :class="['mar-l-5 rotate',showAuthorResponseEditor?'rotate-180':'']"
                     type="iconArrow" />

        </div>
        <div class="ipub-title-tab-part"
             v-show="showAuthorResponseEditor">
          <div class="mar-b-20">
            <div class="ipub-p2 fw-bd fw-bd mar-b-8">
              Comments to Author
            </div>
            <div class="ipub-p2"
                 v-html="articleDetail.autoReplyMeditor.authorNotes?articleDetail.autoReplyMeditor.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' '):'- -'"></div>
          </div>
          <div class="mar-b-20">
            <div class="ipub-p2 fw-bd fw-bd mar-b-8">
              Author Response
            </div>
            <div class="ipub-p2"
                 v-html="articleDetail.autoReplyMeditor.authorReply.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
          </div>

        </div>
      </div>

      <template v-if="!['PENDING_RESUBMISSION', 'PAPER_ACCEPTED', 'REJECTED', 'WITHDRAWN','ONLINE','PENDING_DECISION','PENDING_APC_CONFIRM','SUBMITTED'].includes(articleDetail.status) && articleDetail.signList[0]==articleDetail.sign">
        <div class="mar-b-10">
          <div class="ipub-h3 line-h-40 ipub-title-tab flex mar-b-10"
               style="align-items:center"
               @click="()=>{showAuthorRevision=!showAuthorRevision}">
            Author Revision
            <ipub-icon :class="['mar-l-5 rotate',showAuthorRevision?'rotate-180':'']"
                       type="iconArrow" />
            <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.GO_TO_AUTHOR_REVISION')">
              <ipub-button class="mar-l-10 ipub-p2"
                           style="height:24px"
                           v-if="['PENDING_REVIEW', 'RESUBMISSION', 'REVISED_REVIEW', 'PENDING_PRE_CHECK', 'PRE_CHECK_DONE', 'UNDER_REVIEW','PENDING_FIRST_DECISION','FIRST_DECISION_DONE','PENDING_FINAL_DECISION','FINAL_DECISION_DONE'].includes(articleDetail.status) && articleDetail.signList[0]==articleDetail.sign"
                           @click.stop="Decision(articleDetail.status)"
                           size='small'>
                Author Revision
              </ipub-button>
            </template>
          </div>
          <div class="ipub-title-tab-part"
               v-show="showAuthorRevision">
            <template v-if="['PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS'].includes(articleDetail.status)">
              <div class="mar-b-10"
                   v-if="auReviseData">
                <font class="fw-bd"
                      style="margin-right:10px">Revision</font> {{DECISION_STATUS[auReviseData.decisionStatus]}} (Send at {{auReviseData.completedTime?$moment(auReviseData.completedTime).format('DD / MM / YYYY'):''}})
                <font class="mar-l-10">Last Reminder: {{auReviseData.lastRemindTime?$moment(auReviseData.lastRemindTime).format('DD / MM / YYYY'):'- -'}}</font>
                <font :class="['mar-l-20',$moment(auReviseData.reviseDueTime).diff($moment(),'days')<0? 'key-color':'']">Due Date: {{auReviseData.reviseDueTime?$moment(auReviseData.reviseDueTime).format('DD / MM / YYYY'):'- -'}}</font>
              </div>
              <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.SEND_REVISED_REMIND')">
                <ipub-button @click.stop="sendEmail(articleDetail, 'REMIND_AUTHOR_REVISE','REMIND_AUTHOR_REVISE')"
                             type="primary">
                  <a>Send Reminder</a>
                </ipub-button>
              </template>
              <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.EDIT_REVISION_DUE_DATE')">
                <ipub-button v-if="$moment(auReviseData.reviseDueTime).diff($moment(),'days')<0"
                             @click.stop="editReviseDate"
                             type="primary">
                  <a>Revision Due Date</a>
                </ipub-button>
              </template>
            </template>
          </div>
        </div>
      </template>

      <template v-if="!['SUBMITTED', 'PENDING_REVIEW', 'PENDING_RESUBMISSION', 'PENDING_APC_CONFIRM', 'PENDING_PRE_CHECK', 'PRE_CHECK_DONE'].includes(articleDetail.status)">
        <div class="mar-b-10">
          <div class="ipub-h3 line-h-40 ipub-title-tab flex mar-b-10"
               @click="()=>{showFirstCheck=!showFirstCheck}">First Decision
            <ipub-icon :class="['mar-l-5 rotate',showFirstCheck?'rotate-180':'']"
                       type="iconArrow" />
            <div class="mar-l-10 ipub-p2 line-h-40"
                 v-if="articleDetail.signList[0]===articleDetail.sign">
              <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.START_FIRST_DECISION')">
                <ipub-button @click.stop="endDecision('FIRST_CHECK', true)"
                             type="default"
                             style="height:24px"
                             class="mar-l-10 ipub-p2"
                             size="small"
                             :disabled="['PENDING_FINAL_DECISION', 'FINAL_DECISION_DONE', 'PENDING_DECISION', 'PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS'].includes(articleDetail.status) || (['UNDER_REVIEW'].includes(articleDetail.status) && !macademic.PRE_CHECK.endPreCheck && articleReviewer && articleReviewer.length>0) || (['RESUBMISSION'].includes(articleDetail.status) && !articleDetail.peerConfirmed)"
                             v-if="['UNDER_REVIEW', 'PENDING_FINAL_DECISION', 'FINAL_DECISION_DONE', 'PENDING_DECISION', 'PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS', 'RESUBMISSION', 'REVISED_REVIEW'].includes(articleDetail.status)">
                  <a>Start First Decision</a>
                </ipub-button>
              </template>
              <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.END_FIRST_DECISION')">
                <ipub-button type="default"
                             style="height:24px"
                             class="mar-l-10 ipub-p2"
                             size="small"
                             v-if="['PENDING_FIRST_DECISION', 'FIRST_DECISION_DONE'].includes(articleDetail.status)"
                             @click.stop="endDecision('FIRST_CHECK', false)">End First Decision</ipub-button>
              </template>
            </div>
          </div>
          <div class="ipub-title-tab-part"
               v-show="showFirstCheck">
            <template v-if="['PENDING_FIRST_DECISION', 'FIRST_DECISION_DONE'].includes(articleDetail.status)&&articleDetail.signList[0]===articleDetail.sign">
              <div class="flex"
                   style="align-items: center;">
                <div class="ipub-p2 fw-bd mar-b-4 line-h-40"
                     style="margin-right:20px">Review Document
                  <ipub-tooltip placement="right"
                                type="dark"
                                class="mar-l-10">
                    <div slot="title">Supported file types: PDF, ZIP</div>
                    <ipub-icon type="iconInfo" />
                  </ipub-tooltip>
                </div>
                <div class="line-h-40 ipub-p2 tr"
                     v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.ADD_NEW_REVIEW_DOCUMENT-EDITOR')">
                  <ipub-upload v-if="articleDetail.signList[0]===articleDetail.sign&&!loading.FIRST_CHECK"
                               @change="(e)=>{handleUpload(e, 'FIRST_CHECK')}">
                    <a class="link-color">
                      <ipub-icon type="iconAdd" /> Add New Review Document
                    </a>
                  </ipub-upload>
                  <font v-else
                        class="line-color">
                    <ipub-icon :type="loading.FIRST_CHECK?'loading':'iconAdd'" /> Add New Review Document
                  </font>
                </div>
              </div>
              <div v-if="macademic.FIRST_CHECK">
                <div class="ipub-border ipub-line-block relative mar-b-4"
                     style="padding-right:60px;display: inline-block;margin-right:10px"
                     v-for="item in macademic.FIRST_CHECK.macademicFileList"
                     :key="item.id">
                  {{item.name}}
                  <div class="right-option ipub-p2 flex"
                       style="right: 10px">
                    <ipub-tooltip placement="bottom">
                      <div slot="title">
                        Download
                      </div>
                      <a class="line-h-40"
                         @click="download(`${domain}/${item.path}`, item.name)">
                        <ipub-icon style="font-size:16px"
                                   type="iconDownload1" />
                      </a>
                    </ipub-tooltip>
                    <template v-if="articleDetail.signList[0]===articleDetail.sign && user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.DELETE_REVIEW_DOCUMENT-EDITOR')">
                      <div style="padding: 0 4px"
                           class="line-color line-h-40">|</div>
                      <ipub-tooltip placement="bottom">
                        <div slot="title">
                          Delete
                        </div>
                        <a class="line-h-40"
                           @click="delReviewerDoc(item, 'FIRST_CHECK')">
                          <ipub-icon style="font-size:16px"
                                     type="iconDelete" />
                        </a>
                      </ipub-tooltip>
                    </template>
                  </div>
                </div>
              </div>
              <template>
                <div class="mar-b-12 ipub-p2 flex"
                     v-if="macademic.FIRST_CHECK.person">
                  <span class="ipub-p2 fw-bd">Academic Editor</span>
                  <div class="mar-l-10">
                    <div>
                      <a class="link-color"
                         @click="openReviewResult(macademic.FIRST_CHECK.person, true)">{{macademic.FIRST_CHECK.person.firstName}} {{macademic.FIRST_CHECK.person.lastName}}</a>
                      <span class="mar-l-10">
                        <template v-if="!macademic.FIRST_CHECK.person.decisionStatus">{{macademic.FIRST_CHECK.person.currentDecisionNum}} current decision (last invited on {{macademic.FIRST_CHECK.person.lastInvitedTime?$moment(macademic.FIRST_CHECK.person.lastInvitedTime).format('DD MMMM YYYY'):'--'}})</template>
                        <template v-else>Decision: <font @click="checkDecision('FIRST_CHECK')"
                                class="key-color ipub-c-p">{{DECISION_STATUS[macademic.FIRST_CHECK.person.decisionStatus]}}</font></template>
                      </span>
                    </div>
                    <div v-if="macademic.FIRST_CHECK.invitedTime && macademic.FIRST_CHECK.person"
                         class="ipub-p2 fw-bd">Invited Date: {{$moment(macademic.FIRST_CHECK.invitedTime).format('DD MMMM YYYY')}}</div>
                    <div v-if="macademic.FIRST_CHECK.remindTimeList && macademic.FIRST_CHECK.remindTimeList.length && macademic.FIRST_CHECK.person"
                         class="ipub-p2 fw-bd"> Last Remind Date:
                      <span v-for="(item,index) in macademic.FIRST_CHECK.remindTimeList"
                            :key="'PRE_CHECK'+index">
                        <div class="mar-l-10 inline-block">{{$moment(item).format('DD MMMM YYYY')}}</div>
                        <div class="mar-l-10 inline-block"
                             v-if="index !=macademic.FIRST_CHECK.remindTimeList.length-1">/</div>
                      </span>
                      <span class="ipub-count mar-l-10"> {{macademic.FIRST_CHECK.remindTimeList.length}}</span>
                    </div>

                  </div>
                </div>
                <div class="mar-b-20 ipub-p2 fw-bd">
                  <template v-if="macademic.FIRST_CHECK.person">
                    <template v-if="macademic.FIRST_CHECK.person.decisionStatus">
                      <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.CHECK_DECISION')">
                        <ipub-button @click="checkDecision('FIRST_CHECK')"
                                     type="primary"
                                     size="small"
                                     plain>Check Decision</ipub-button>
                      </template>
                      <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.ACKNOWLEDGE_ACADEMIC_EDITOR')">
                        <ipub-button v-if="!macademic.FIRST_CHECK.acked"
                                     @click="sendEmail(macademic.FIRST_CHECK, macademic.FIRST_CHECK.geed?'GE_FIRST_DECISION_ACK':'FIRST_CHECK_ACK','first_check_ack')"
                                     type="primary"
                                     size="small"
                                     plain>Acknowledge</ipub-button>
                      </template>

                    </template>
                    <template v-else>
                      <template v-if="!macademic.FIRST_CHECK.invitedTime">
                        <ipub-button v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.INVITE_ACADEMIC_EDITOR')"
                                     @click="invite(macademic.FIRST_CHECK,'FIRST_CHECK',macademic.FIRST_CHECK.geed?'GE_INVITE_FIRST_DECISION':'INVITE_FIRST_CHECK')"
                                     type="primary"
                                     size="small"
                                     plain>Invite</ipub-button>
                      </template>
                      <template v-else>
                        <template v-if="macademic.FIRST_CHECK.sended">
                          <ipub-button v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.REMIND_ACADEMIC_EDITOR')"
                                       @click="sendEmail(macademic.FIRST_CHECK, macademic.FIRST_CHECK.geed?'GE_FIRST_DECISION_REMIND':'FIRST_CHECK_REMIND','FIRST_DECISION_REMIND')"
                                       type="primary"
                                       size="small"
                                       plain>Remind</ipub-button>
                          <ipub-button v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.CANCEL_INVITE_ACADEMIC_EDITOR')"
                                       @click="sendEmail(macademic.FIRST_CHECK,macademic.FIRST_CHECK.geed?'GE_FIRST_DECISION_CANCEL':'FIRST_CANCEL_INVITE','FIRST_CHECK')"
                                       type="primary"
                                       size="small"
                                       plain>Cancel Invitation</ipub-button>
                        </template>
                        <ipub-button v-else
                                     @click="sendEmail(macademic.FIRST_CHECK,macademic.FIRST_CHECK.geed?'GE_INVITE_FIRST_DECISION':'INVITE_FIRST_CHECK','INVITE_FIRST_CHECK')"
                                     type="primary"
                                     size="small"
                                     plain>Send Invitation Email</ipub-button>
                      </template>
                    </template>
                  </template>
                  <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.CHOOSE_ANOTHER_EDITOR')">
                    <ipub-button @click="chooseAnotherEditor(macademic.FIRST_CHECK.person, 'FIRST_CHECK')"
                                 v-if="macademic.FIRST_CHECK.sended!=false"
                                 type="primary"
                                 size="small"
                                 plain>Choose another editor</ipub-button>
                  </template>
                </div>
              </template>
            </template>
            <div v-for="item in macademic.FIRST_CHECK.macademicHistoryList"
                 :key="item.id"
                 class="ipub-bottom-border relative mar-b-8 ipub-p2">
              <div class="mar-b-8">
                <a class="ipub-h3 link-color"
                   @click="openReviewResult(item.person, true)"
                   v-if="item.person">{{title[item.person.titleCode]}} {{item.person.firstName}} {{item.person.lastName}} </a><span class="ipub-p2">({{item.person.email}})</span>

                <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.ACKNOWLEDGE_ACADEMIC_EDITOR')">
                  <a v-if="!item.acked  && item.decisionStatus"
                     @click="sendEmail(item, macademic.FIRST_CHECK.geed?'GE_FIRST_DECISION_ACK':'FIRST_CHECK_ACK','first_check_ack')"
                     class="link-color ipub-p2 fw-bd mar-l-20">Acknowledge</a>
                </template>
              </div>
              <div class="mar-b-8 flex">
                <span class="ipub-p2 fw-bd"
                      style="width: 110px">Invited Date</span>
                <span class="mar-l-10"
                      style="width: calc(100% - 120px)">
                  {{item.invitedTime?$moment(item.invitedTime).format('HH:mm DD / MMMM / YYYY'):'--'}}
                </span>
              </div>
              <div class="mar-b-8 flex">
                <span class="ipub-p2 fw-bd"
                      style="width: 110px">Decision</span>
                <span class="mar-l-10 ipub-cursor-pointer"
                      style="width: calc(100% - 120px)"
                      @click="showDecision(item,'FIRST_CHECK')">
                  <font class="key-color"
                        v-if="item.decisionStatus">{{DECISION_STATUS[item.decisionStatus]}}</font>
                  <font v-else>--</font>
                </span>
              </div>
              <div class="mar-b-8 flex"
                   v-if="item.authorNotes">
                <span class="ipub-p2 fw-bd"
                      style="width: 110px">Comments</span>
                <div style="display: inline-block; width: calc(100% - 120px)"
                     class="mar-l-10">
                  <template v-if="item.authorNotes.length>500">
                    <div v-if="showAuthorNotes.FIRST_CHECK"
                         v-html="item.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                    <div v-else
                         v-html="item.authorNotes.substr(0, 500).replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')+'...'"></div>
                    <a class="link-color"
                       @click="()=>{showAuthorNotes.FIRST_CHECK = !showAuthorNotes.FIRST_CHECK}">
                      {{showAuthorNotes.FIRST_CHECK?'Hidden':'View More'}}
                    </a>
                  </template>
                  <div v-else
                       v-html="item.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')">
                  </div>
                </div>
              </div>
              <div class="mar-b-8 flex">
                <span class="ipub-p2 fw-bd"
                      style="width: 110px">Decision Date</span>
                <span class="mar-l-10"
                      style="width: calc(100% - 120px)">
                  {{item.completedTime?$moment(item.completedTime).format('HH:mm DD / MMMM / YYYY'):'--'}}
                </span>
              </div>
              <template v-if="item.authorReply||(item.authorReplyFileList&&item.authorReplyFileList.length)">
                <div class="ipub-p2 fw-bd mar-b-8 ipub-c-p"
                     @click="()=>{showAEC.FIRST_CHECK=!showAEC.FIRST_CHECK}">
                  Author Response to Academic Editor’s Comments
                  <ipub-icon :class="['mar-l-10 rotate',showAEC.FIRST_CHECK?'rotate-180':'']"
                             type="iconArrow" />
                </div>
                <template v-if="showAEC.FIRST_CHECK">
                  <ipub-textarea v-if="editAEC.FIRST_CHECK"
                                 class="mar-b-16"
                                 v-model="authorReply.authorReply"></ipub-textarea>
                  <ipub-textarea v-else
                                 :disabled="true"
                                 class="mar-b-16"
                                 v-model="item.authorReply"></ipub-textarea>
                  <div class="flex"
                       style="align-items: center;">
                    <div class="ipub-p2 fw-bd mar-b-4"
                         style="margin-right:20px">Attachment(s)
                    </div>
                    <div class="ipub-p2">
                      <ipub-upload v-if="editAEC.FIRST_CHECK&&!authorReply.loading"
                                   @change="(e)=>{handleUpload(e, 'FIRST_CHECK', 'AEC')}">
                        <a class="link-color">
                          <ipub-icon type="iconAdd" /> Add New Review Document
                        </a>
                      </ipub-upload>
                      <font class="line-color"
                            v-else>
                        <ipub-icon :type="authorReply.loading?'loading':'iconAdd'" /> Add New Review Document
                      </font>
                    </div>
                  </div>
                  <div class="ipub-border ipub-line-block relative mar-b-4"
                       style="padding-right:60px;display: inline-block;margin-right:10px"
                       v-for="(item, index) in editAEC.FIRST_CHECK?authorReply.authorReplyFileList:item.authorReplyFileList"
                       :key="item.id">
                    {{item.name}}
                    <div class="right-option ipub-p2 flex"
                         style="right: 10px">
                      <ipub-tooltip placement="bottom">
                        <div slot="title">
                          Download
                        </div>
                        <a class="line-h-40"
                           @click="download(`${domain}/${item.path}`, item.name)">
                          <ipub-icon style="font-size:16px"
                                     type="iconDownload1" />
                        </a>
                      </ipub-tooltip>
                      <template v-if="editAEC.FIRST_CHECK">
                        <div style="padding: 0 4px"
                             class="line-color line-h-40">|</div>
                        <ipub-tooltip placement="bottom">
                          <div slot="title">
                            Delete
                          </div>
                          <a class="line-h-40"
                             @click="delAECDoc(index)">
                            <ipub-icon style="font-size:16px"
                                       type="iconDelete" />
                          </a>
                        </ipub-tooltip>
                      </template>
                    </div>
                  </div>
                  <div class="ipub-p2 fw-bd mar-b-20"
                       style="margin-top:20px">
                    <template v-if="!editAEC.FIRST_CHECK">
                      <ipub-button style="height:30px;line-height:30px"
                                   type="primary"
                                   @click="sendAE(item, 'FIRST_CHECK')">Edit and Send to Academic Editor</ipub-button>
                    </template>
                    <template v-else>
                      <ipub-button style="height:30px;line-height:30px"
                                   plain
                                   type="primary"
                                   @click="cancelAE('FIRST_CHECK')">Cancel</ipub-button>
                      <ipub-button style="height:30px;line-height:30px"
                                   type="primary"
                                   @click="confirmAE('FIRST_CHECK')">Confirm</ipub-button>
                    </template>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
        <div class=" mar-b-10">
          <div class="mar-b-12">
            <div class="ipub-h3 line-h-40 ipub-title-tab "
                 @click="()=>{showFinalCheck=!showFinalCheck}">Final Decision
              <ipub-icon :class="['mar-l-5 rotate',showFinalCheck?'rotate-180':'']"
                         type="iconArrow" />
              <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.START_FINAL_DECISION')">
                <ipub-button class="mar-l-10 ipub-p2"
                             @click.stop="endDecision('FINAL_CHECK', true)"
                             type="default"
                             style="height:24px"
                             size="small"
                             :disabled="['PENDING_FIRST_DECISION', 'FIRST_DECISION_DONE', 'PENDING_DECISION', 'PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS'].includes(articleDetail.status)  || (['RESUBMISSION'].includes(articleDetail.status) && !articleDetail.peerConfirmed) || (['UNDER_REVIEW'].includes(articleDetail.status) && !macademic.PRE_CHECK.endPreCheck && articleReviewer && articleReviewer.length>0) "
                             v-if="articleDetail.signList[0]===articleDetail.sign && ['UNDER_REVIEW', 'PENDING_FIRST_DECISION', 'FIRST_DECISION_DONE', 'PENDING_DECISION', 'PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS', 'RESUBMISSION', 'REVISED_REVIEW'].includes(articleDetail.status)">
                  <template>
                    <font class="ipub-p2">Start Final Decision</font>
                    <!-- <font v-else>Start Final Decision</font> -->
                  </template>
                </ipub-button>
              </template>

            </div>
          </div>
          <div class="ipub-title-tab-part"
               v-show="showFinalCheck">
            <template v-if="['PENDING_FINAL_DECISION', 'FINAL_DECISION_DONE'].includes(articleDetail.status)&&articleDetail.signList[0]===articleDetail.sign">
              <div class="flex"
                   style="align-items: center;">
                <div class="ipub-p2 fw-bd mar-b-4 line-h-40"
                     style="margin-right:20px">Review Document
                  <ipub-tooltip placement="right"
                                type="dark"
                                class="mar-l-10">
                    <div slot="title">Supported file types: PDF, ZIP</div>
                    <ipub-icon type="iconInfo" />
                  </ipub-tooltip>
                </div>
                <div class="line-h-40 ipub-p2 tr"
                     v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.ADD_NEW_REVIEW_DOCUMENT-EDITOR')">
                  <ipub-upload v-if="articleDetail.signList[0]===articleDetail.sign&&!loading.FINAL_CHECK"
                               @change="(e)=>{handleUpload(e, 'FINAL_CHECK')}">
                    <a class="link-color">
                      <ipub-icon type="iconAdd" /> Add New Review Document
                    </a>
                  </ipub-upload>
                  <font class="line-color"
                        v-else>
                    <ipub-icon :type="loading.FINAL_CHECK?'loading':'iconAdd'" /> Add New Review Document
                  </font>
                </div>
              </div>
              <div v-if="macademic.FINAL_CHECK">
                <div class="ipub-border ipub-line-block relative mar-b-4"
                     style="padding-right:60px;display: inline-block;margin-right:10px"
                     v-for="item in macademic.FINAL_CHECK.macademicFileList"
                     :key="item.id">
                  {{item.name}}
                  <div class="right-option ipub-p2 flex"
                       style="right: 10px">
                    <ipub-tooltip placement="bottom">
                      <div slot="title">
                        Download
                      </div>
                      <a class="line-h-40"
                         @click="download(`${domain}/${item.path}`, item.name)">
                        <ipub-icon style="font-size:16px"
                                   type="iconDownload1" />
                      </a>
                    </ipub-tooltip>
                    <template v-if="articleDetail.signList[0]===articleDetail.sign">
                      <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.DELETE_REVIEW_DOCUMENT-EDITOR')">
                        <div style="padding: 0 4px"
                             class="line-color line-h-40">|</div>
                        <ipub-tooltip placement="bottom">
                          <div slot="title">
                            Delete
                          </div>
                          <a class="line-h-40"
                             @click="delReviewerDoc(item, 'FINAL_CHECK')">
                            <ipub-icon style="font-size:16px"
                                       type="iconDelete" />
                          </a>
                        </ipub-tooltip>
                      </template>

                    </template>
                  </div>
                </div>
              </div>
              <template>
                <div class="mar-b-12 ipub-p2 flex"
                     v-if="macademic.FINAL_CHECK.person">
                  <span class="ipub-p2 fw-bd">Academic Editor</span>
                  <div class="mar-l-10">
                    <div>
                      <a class="link-color"
                         @click="openReviewResult(macademic.FINAL_CHECK.person, true)">{{macademic.FINAL_CHECK.person.firstName}} {{macademic.FINAL_CHECK.person.lastName}}</a>
                      <span class="mar-l-10">
                        <template v-if="!macademic.FINAL_CHECK.person.decisionStatus">{{macademic.FINAL_CHECK.person.currentDecisionNum}} current decision (last invited on {{macademic.FINAL_CHECK.person.lastInvitedTime?$moment(macademic.FINAL_CHECK.person.lastInvitedTime).format('DD MMMM YYYY'):'--'}})</template>
                        <template v-else>Decision: <font @click="checkDecision('FINAL_CHECK')"
                                class="key-color">{{DECISION_STATUS[macademic.FINAL_CHECK.person.decisionStatus]}}</font></template>
                      </span>
                    </div>
                    <div v-if="macademic.FINAL_CHECK.invitedTime && macademic.FINAL_CHECK.person"
                         class="ipub-p2 fw-bd">Invited Date: {{$moment(macademic.FINAL_CHECK.invitedTime).format('DD MMMM YYYY')}}</div>
                    <div v-if="macademic.FINAL_CHECK.remindTimeList && macademic.FINAL_CHECK.remindTimeList.length && macademic.FINAL_CHECK.person"
                         class="ipub-p2 fw-bd"> Last Remind Date:
                      <span v-for="(item,index) in macademic.FINAL_CHECK.remindTimeList"
                            :key="'PRE_CHECK'+index">
                        <div class="mar-l-10 inline-block">{{$moment(item).format('DD MMMM YYYY')}}</div>
                        <div class="mar-l-10 inline-block"
                             v-if="index !=macademic.FINAL_CHECK.remindTimeList.length-1">/</div>
                      </span>
                      <span class="ipub-count mar-l-10"> {{macademic.FINAL_CHECK.remindTimeList.length}}</span>
                    </div>

                  </div>
                </div>
                <div class="mar-b-20 ipub-p2 fw-bd">
                  <template v-if="macademic.FINAL_CHECK.person">
                    <template v-if="macademic.FINAL_CHECK.person.decisionStatus">
                      <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.CHECK_DECISION')">
                        <ipub-button @click="checkDecision('FINAL_CHECK')"
                                     type="primary"
                                     size="small"
                                     plain>Check Decision</ipub-button>
                      </template>
                      <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.ACKNOWLEDGE_ACADEMIC_EDITOR')">
                        <ipub-button v-if="!macademic.FINAL_CHECK.acked"
                                     @click="sendEmail(macademic.FINAL_CHECK, macademic.FINAL_CHECK.geed?'GE_FINAL_DECISION_ACK':'FINAL_CHECK_ACK','final_check_ack')"
                                     type="primary"
                                     size="small"
                                     plain>Acknowledge</ipub-button>
                      </template>

                    </template>
                    <template v-else>
                      <template v-if="!macademic.FINAL_CHECK.invitedTime">
                        <ipub-button v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.INVITE_ACADEMIC_EDITOR')"
                                     @click="invite(macademic.FINAL_CHECK,'FINAL_CHECK',macademic.FINAL_CHECK.geed?'GE_INVITE_FINAL_DECISION':'INVITE_FINAL_CHECK')"
                                     type="primary"
                                     size="small"
                                     plain>Invite</ipub-button>
                      </template>

                      <template v-else>
                        <template v-if="macademic.FINAL_CHECK.sended">
                          <ipub-button v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.REMIND_ACADEMIC_EDITOR')"
                                       @click="sendEmail(macademic.FINAL_CHECK,macademic.FINAL_CHECK.geed?'GE_FINAL_DECISION_REMIND':'FINAL_CHECK_REMIND','FINAL_DECISION_REMIND')"
                                       type="primary"
                                       size="small"
                                       plain>Remind</ipub-button>
                          <ipub-button v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.CANCEL_INVITE_ACADEMIC_EDITOR')"
                                       @click="sendEmail(macademic.FINAL_CHECK,macademic.FINAL_CHECK.geed?'GE_FINAL_DECISION_CANCEL':'FINAL_CANCEL_INVITE','FINAL_CHECK')"
                                       type="primary"
                                       size="small"
                                       plain>Cancel Invitation</ipub-button>
                        </template>
                        <ipub-button v-else
                                     @click="sendEmail(macademic.FINAL_CHECK,macademic.FINAL_CHECK.geed?'GE_INVITE_FINAL_DECISION':'INVITE_FINAL_CHECK','INVITE_FINAL_CHECK')"
                                     type="primary"
                                     size="small"
                                     plain>Send Invitation Email</ipub-button>
                      </template>
                    </template>
                  </template>
                  <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.CHOOSE_ANOTHER_EDITOR')">
                    <ipub-button @click="chooseAnotherEditor(macademic.FINAL_CHECK.person, 'FINAL_CHECK')"
                                 v-if="macademic.FINAL_CHECK.sended!=false"
                                 type="primary"
                                 size="small"
                                 plain>Choose another editor</ipub-button>
                  </template>

                </div>
              </template>
            </template>
            <div v-for="item in macademic.FINAL_CHECK.macademicHistoryList"
                 :key="item.id"
                 class="ipub-bottom-border relative mar-b-8 ipub-p2">
              <div class="mar-b-8">
                <a class="ipub-h3 link-color"
                   @click="openReviewResult(item.person, true)"
                   v-if="item.person">{{title[item.person.titleCode]}} {{item.person.firstName}} {{item.person.lastName}} </a><span class="ipub-p2">({{item.person.email}})</span>
                <a v-if="!item.acked  && item.decisionStatus"
                   @click="sendEmail(item, macademic.FINAL_CHECK.geed?'GE_FINAL_DECISION_ACK':'FINAL_CHECK_ACK','final_check_ack')"
                   class="link-color ipub-p2 fw-bd mar-l-20">Acknowledge</a>
              </div>
              <div class="mar-b-8 flex">
                <span class="ipub-p2 fw-bd"
                      style="width: 110px">Invited Date</span>
                <span class="mar-l-10"
                      style="width: calc(100% - 120px)">
                  {{item.invitedTime?$moment(item.invitedTime).format('HH:mm DD / MMMM / YYYY'):'--'}}
                </span>
              </div>
              <div class="mar-b-8 flex">
                <span class="ipub-p2 fw-bd"
                      style="width: 110px">Decision</span>
                <span class="mar-l-10 ipub-cursor-pointer"
                      style="width: calc(100% - 120px)"
                      @click="showDecision(item,'FINAL_CHECK')">
                  <font class="key-color"
                        v-if="item.decisionStatus">{{DECISION_STATUS[item.decisionStatus]}}</font>
                  <font v-else>--</font>
                </span>
              </div>
              <div class="mar-b-8 flex"
                   v-if="item.authorNotes">
                <span class="ipub-p2 fw-bd"
                      style="width: 110px">Comments</span>
                <div style="display: inline-block; width: calc(100% - 120px)"
                     class="mar-l-10">
                  <template v-if="item.authorNotes.length>500">
                    <div v-if="showAuthorNotes.FINAL_CHECK"
                         v-html="item.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                    <div v-else
                         v-html="item.authorNotes.substr(0, 500).replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')+'...'"></div>
                    <a class="link-color"
                       @click="()=>{showAuthorNotes.FINAL_CHECK = !showAuthorNotes.FINAL_CHECK}">
                      {{showAuthorNotes.FINAL_CHECK?'Hidden':'View More'}}
                    </a>
                  </template>
                  <div v-else
                       v-html="item.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')">
                  </div>
                </div>
              </div>
              <div class="mar-b-8 flex">
                <span class="ipub-p2 fw-bd"
                      style="width: 110px">Decision Date</span>
                <span class="mar-l-10"
                      style="width: calc(100% - 120px)">
                  {{item.completedTime?$moment(item.completedTime).format('HH:mm DD / MMMM / YYYY'):'--'}}
                </span>
              </div>
              <template v-if="item.authorReply||(item.authorReplyFileList&&item.authorReplyFileList.length)">
                <div class="ipub-p2 fw-bd mar-b-8 ipub-c-p"
                     @click="()=>{showAEC.FINAL_CHECK=!showAEC.FINAL_CHECK}">
                  Author Response to Academic Editor’s Comments
                  <ipub-icon :class="['mar-l-10 rotate',showAEC.FINAL_CHECK?'rotate-180':'']"
                             type="iconArrow" />
                </div>
                <template v-if="showAEC.FINAL_CHECK">
                  <ipub-textarea v-if="editAEC.FINAL_CHECK"
                                 class="mar-b-16"
                                 v-model="authorReply.authorReply"></ipub-textarea>
                  <ipub-textarea v-else
                                 :disabled="true"
                                 class="mar-b-16"
                                 v-model="item.authorReply"></ipub-textarea>
                  <div class="flex"
                       style="align-items: center;">
                    <div class="ipub-p2 fw-bd mar-b-4"
                         style="margin-right:20px">Attachment(s)
                    </div>
                    <div class="ipub-p2 tr">
                      <ipub-upload v-if="editAEC.FINAL_CHECK&&!authorReply.loading"
                                   @change="(e)=>{handleUpload(e, 'FINAL_CHECK', 'AEC')}">
                        <a class="link-color">
                          <ipub-icon type="iconAdd" /> Add New Review Document
                        </a>
                      </ipub-upload>
                      <font class="line-color"
                            v-else>
                        <ipub-icon :type="authorReply.loading?'loading':'iconAdd'" /> Add New Review Document
                      </font>
                    </div>
                  </div>
                  <div class="ipub-border ipub-line-block relative mar-b-4"
                       style="padding-right:60px;display: inline-block;margin-right:10px"
                       v-for="(item, index) in editAEC.FINAL_CHECK?authorReply.authorReplyFileList:item.authorReplyFileList"
                       :key="item.id">
                    {{item.name}}
                    <div class="right-option ipub-p2 flex"
                         style="right: 10px">
                      <ipub-tooltip placement="bottom">
                        <div slot="title">
                          Download
                        </div>
                        <a class="line-h-40"
                           @click="download(`${domain}/${item.path}`, item.name)">
                          <ipub-icon style="font-size:16px"
                                     type="iconDownload1" />
                        </a>
                      </ipub-tooltip>
                      <template v-if="editAEC.FINAL_CHECK">
                        <div style="padding: 0 4px"
                             class="line-color line-h-40">|</div>
                        <ipub-tooltip placement="bottom">
                          <div slot="title">
                            Delete
                          </div>
                          <a class="line-h-40"
                             @click="delAECDoc(index)">
                            <ipub-icon style="font-size:16px"
                                       type="iconDelete" />
                          </a>
                        </ipub-tooltip>
                      </template>
                    </div>
                  </div>
                  <div class="ipub-p2 fw-bd mar-b-20"
                       style="margin-top:20px">
                    <template v-if="!editAEC.FINAL_CHECK">
                      <ipub-button style="height:30px;line-height:30px"
                                   type="primary"
                                   @click="sendAE(item, 'FINAL_CHECK')">Edit and Send to Academic Editor</ipub-button>
                    </template>
                    <template v-else>
                      <ipub-button style="height:30px;line-height:30px"
                                   plain
                                   type="primary"
                                   @click="cancelAE('FINAL_CHECK')">Cancel</ipub-button>
                      <ipub-button style="height:30px;line-height:30px"
                                   type="primary"
                                   @click="confirmAE('FINAL_CHECK')">Confirm</ipub-button>
                    </template>
                  </div>
                </template>
              </template>
            </div>
          </div>

        </div>
      </template>
      <div class="mar-b-10"
           v-if="['SUBMITTED', 'PENDING_REVIEW', 'PENDING_RESUBMISSION', 'PENDING_APC_CONFIRM'].includes(articleDetail.status) && articleDetail.signList[0]===articleDetail.sign && user.codeList && user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.DECISION_TO_AUTHOR')">
        <div class="ipub-h3 line-h-40 ipub-title-tab mar-b-10"
             @click="()=>{showDecisionToAuthor=!showDecisionToAuthor}">Decision to Author
          <ipub-icon :class="['mar-l-5 rotate',showDecisionToAuthor?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div class="ipub-title-tab-part"
             v-show="showDecisionToAuthor">
          <div class="line-h-40 flex mar-b-20">
            <span class="ipub-p2 fw-bd">Decision <font class="key-color">*</font> </span>
            <ipub-radio-group class="flex-center mar-l-20"
                              v-model="decision.decisionStatus"
                              _label="name"
                              :options="decisionList" />
          </div>

          <div class=" mar-b-20"
               v-if="decision.decisionStatus === 'REJECTED'">
            <div class="ipub-p2 fw-bd mar-b-10">Reject Reason(Visible Only in Editorial Office)<font class="key-color">*</font>
            </div>
            <div>
              <div class="wrapper">
                <ul class="item_wrapper">
                  <li class="item_first mar-b-10"
                      v-for="(item,index) in refuseList"
                      :key="item.index">
                    <div @click="checkItem(index)"
                         class="item">
                      <input type="radio"
                             name="root"
                             class="radio-select"
                             :checked="item.checked">
                      <label :for="'ipub-radio-group'+(item.id||item.name||index)"></label>
                      {{item.name}}
                    </div>
                    <ul class="item_second mar-l-20"
                        style="margin-top:10px;"
                        v-show="isOpenItem[index] && isOpenItem[index].group">
                      <li v-for="(node,i) in item.children"
                          class="mar-b-10"
                          :key="node.i">
                        <input @click="stateChanged(node,index,i)"
                               type="radio"
                               :id="'ipub-radio-group'+(node.id||node.name||i)"
                               class="radio-select"
                               name="leaf"
                               :checked="node.checked">
                        <label :for="'ipub-radio-group'+(node.id||node.name||i)"></label>
                        <label class="radio-content"
                               :for="'check'+i">
                          {{node.name}}
                        </label>
                        <ipub-textarea class=" mar-l-20"
                                       placeholder="Please enter the other reject reason in details"
                                       style="margin-top:10px;width: 650px;display: block;"
                                       v-show="node.check"
                                       v-model="othersReason" />
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div v-if="['PENDING_MINOR_REVISIONS','PENDING_MAJOR_REVISIONS'].includes(decision.decisionStatus)"
               class="flex mar-b-20">
            <span class="line-h-40 ipub-p2 fw-bd">Revision Due Date</span>
            <ipub-date-picker style="width: 200px"
                              class="mar-l-20"
                              placeholder="Revision Due Date"
                              v-model="decision.reviseDueTime" />
          </div>
          <ipub-button style="width:128px"
                       type="primary"
                       size="small"
                       :disabled="!decision.decisionStatus || !(user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.DECISION_TO_AUTHOR.SEND_TO_AUTHOR'))"
                       @click="submitDecision"
                       class="ipub-p2 fw-bd">Submit</ipub-button>
        </div>
      </div>

      <div class="mar-b-10">
        <div class="ipub-h3 line-h-40 ipub-title-tab mar-b-10"
             @click="()=>{showSubmittedByEditors=!showSubmittedByEditors}">Current Version Assignment Editor
          <ipub-icon :class="['mar-l-5 rotate',showSubmittedByEditors?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div class="ipub-title-tab-part"
             v-show="showSubmittedByEditors">
          <ipub-table :columns="columnsEditors"
                      border
                      :pagination="false"
                      :dataSource="articleEditor">
            <template v-slot:decisionStatus="{text,record}">
              <template v-if="text">
                <a class="flex-center"
                   @click="openEditorDecision(record)">
                  <!-- <div style="width:12px;height:12px;border-radius:6px"
                       :class="'ipub-decision-count-item--'+text"></div> -->
                  <!-- <font :class="['mar-l-10', 'ipub-decision-status-item--'+text]"></font> -->
                  <ipub-label class="mar-l-10"
                              style="border:none;min-width:107px"
                              :type="text==='ACCEPT_CURRENT'?'success':(text==='REJECTED'?'danger':'default')"
                              cover>{{DECISION_STATUS[text]}}</ipub-label>
                </a>
              </template>

              <template v-else>- -</template>
            </template>
            <template v-slot:rolelist="{text}">
              <template v-if="text && text.length">
                {{text.map(item=>{return `${item.journal?item.journal.name+' ':''}${item.name}`}).join(', ')}}
              </template>
              <template v-else>- -</template>
            </template>
            <template v-slot:elapsed="{record}">
              <template v-if="record.completedTime&&record.assignedTime">{{$moment(record.completedTime).diff($moment(record.assignedTime), 'days')+1}} days</template>
              <template v-else>- -</template>
            </template>
          </ipub-table>
        </div>
      </div>
    </div>
    <ipub-backtop />
    <detail-actions :ReviewHistoryScrollTop="ReviewHistoryScrollTop"
                    ref="detail-action"
                    :data="articleDetail"
                    @sendEmail="(e,type)=>{sendEmail(articleDetail, e, type)}"
                    @confirm="confirm" />
    <AssignEditorDialog :isVisable="showAssignEditor"
                        :inputData="inputData"
                        @confirm="confirm"
                        @cancel="cancel" />
    <SelectEditorDialog :isVisable="showSelectEditor"
                        :inputData="inputData"
                        :detail="articleDetail"
                        :decisionType="decisionType"
                        @confirm="changeDecisionEditor"
                        @cancel="cancel" />
    <ChangeDueDate :isVisable="showChangeDueDate"
                   :inputData="inputData"
                   @sendEmail="(e)=>{sendEmail(e, 'CHANGE_REVIEW_DUE_DATE','change_review_due_date')}"
                   @confirm="confirm"
                   @cancel="cancel" />
    <ManuscriptVersions :isVisable="showManuscriptVersions"
                        :inputData="inputData"
                        @cancel="cancel" />
    <UpdateFiles :isVisable="showUpdateFiles"
                 :inputData="inputData"
                 @confirm="confirm"
                 @cancel="cancel" />
    <AddReviewer :isVisable="showAddReviewer"
                 :inputData="inputData"
                 :journalList="journalList"
                 @confirm="(e)=>{searchReviewers(e.email)}"
                 @cancel="cancel" />
    <SearchReviewer :isVisable="showSearchReviewer"
                    :inputData="inputData"
                    :journalList="journalList"
                    @confirm="addReviewerList"
                    @cancel="cancel" />
    <Transfer :isVisable="showTransfer"
              :inputData="inputData"
              :journalList="journalList"
              @confirm="confirm"
              @cancel="cancel" />
    <AuthorQuestionnaire :isVisable="showAuthorQuestionnaire"
                         :inputData="inputData"
                         @cancel="cancel" />
    <ReviewResult :isVisable="showReviewResult"
                  :mac="mac"
                  :inputData="inputData"
                  @cancel="cancel" />
    <RejectReason :isVisable="showRejectReason"
                  :inputData="inputData"
                  @cancel="cancel" />
    <ReviewSelect :isVisable="showReviewSelect"
                  :inputData="inputData"
                  @confirm="(e)=>{searchReviewers(e.email)}"
                  @cancel="cancel" />
    <EditorDecision :isVisable="showEditorDecision"
                    :inputData="inputData"
                    @cancel="cancel" />
    <SendEmail :isVisable="showSendEmail"
               :inputData="inputData"
               :event="event"
               :files="sendFiles"
               @send="send"
               @cancel="cancel" />

    <endConfirm :isVisable="endConfirm"
                :inputData="inputData"
                @confirm="confirm"
                @cancel="cancel" />

    <hindexConfirm :isVisable="hindexDialog"
                   :inputData="inputData"
                   @confirm="cancel"
                   @cancel="cancel" />

    <reviewReport :isVisable="showReviewReport"
                  :inputData="inputData"
                  @confirm="decisionConfirm"
                  @cancel="cancel" />
    <reviewLimit :isVisable="showReviewLimit"
                 :inputData="inputData"
                 @confirm="confirmInvitateReview"
                 @cancel="cancel" />
    <importReview :isVisable="showImportReview"
                  :inputData="inputData"
                  @confirm="confirm"
                  @cancel="cancel" />
    <CreatePNG :isVisable="isVisablePDF"
               :inputData="inputData"
               :type="pdfType"
               :journalId="articleDetail.journalId"
               @confirm="cancel"
               @cancel="cancel" />
    <AddCheckedDialog :isVisable="showCheck"
                      :inputData="inputData"
                      :checked="articleDetail.checked"
                      @confirm="confirm"
                      @cancel="cancel" />
    <EditDate :isVisable="showEditDate"
              :inputData="inputData"
              @confirm="confirmReviseDate"
              @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
.ipub-bottom-border {
  border-bottom: 1px solid #bebebe;
  &:nth-last-child(1) {
    border-bottom: none;
  }
}
.hover-link {
  &:hover {
    color: $link_color;
  }
}
.color-label {
  color: $content_color;
}
</style>

<script>
import main from './main'
export default main
</script>
